/*! © 2026 AirX (airx.art). All rights reserved. Unauthorized copying, reproduction, or redistribution of this code is prohibited. Report infringement: info@airx.art */

const AirX = window.AirX;

const HEALTH_TIMEOUT = 3000;
const HEALTH_HEARTBEAT_MS = 60000;
const FETCH_TIMEOUT = 8000;
const STREAM_TIMEOUT = 90000;
const MAX_MESSAGES = 20;
const MAX_CONTENT = 2000;
const MAX_PRODUCTS = 20;
const MAX_TRANSCRIPT = 40;
const MAX_CARDS = 6;
const MAX_EXCLUDE = 60;
const PRODUCTS_PER_CATEGORY = 20;
const CHIP_COUNT = 16;
const CHIP_MIN_PRODUCTS = 6;
const PULSE_DELAY_MS = 8000;

const LINK_THUMBS = {

  '/pages/ai-art-studio':
    'https://cdn.shopify.com/s/files/1/0689/9328/6301/files/28Leaning_Landscape_Canvas_Ratio_3x1_Mockup_-_Left_0.75_In_WrapVangogh_Blooming_Meadow_Scaled__00112.jpg?v=1745037865&width=320',
  '/pages/print-your-photo':
    'https://cdn.shopify.com/s/files/1/0689/9328/6301/files/Image_20260521221948_1_1.png?v=1781076048&width=320',
  '/pages/design-your-wall':
    'https://cdn.shopify.com/s/files/1/0689/9328/6301/files/EternalWaveLivingRoom1.png?v=1749533023&width=320',

  '/pages/gallery':
    'https://cdn.shopify.com/s/files/1/0689/9328/6301/files/AirX_Museum_Entrance_Banner.jpg?width=320',
};

const DESCRIBE_LINK = '/pages/ai-art-studio?mode=describe';

const MUSEUM_WORD = 'museum(?![\\s-]*(?:quality|grade|piece|standard|level|worthy))';

const GALLERY_WORD = 'gallery(?![\\s-]+walls?\\b)';
const REPLY_LINK_RULES = [
  {
    key: 'linkMuseum',
    ask: 'askMuseum',
    u: '/pages/gallery',
    re: new RegExp(
      '\\b(?:3d|virtual)\\s+(?:' + MUSEUM_WORD + '|' + GALLERY_WORD + ')'
        + '|\\b(?:our|airx(?:[\'’]s)?)\\s+(?:3d\\s+)?' + MUSEUM_WORD
        + '|\\bwalk(?:s|ing)?[\\s-]+(?:through[\\s-]+)?(?:the|our)[\\s-]+(?:3d[\\s-]+|virtual[\\s-]+)?(?:' + GALLERY_WORD + '|' + MUSEUM_WORD + '|halls)'
        + '|\\b' + MUSEUM_WORD + '\\b[^.?!]{0,50}\\b(?:real|true|actual|life)[\\s-]+(?:scale|size)'
        + '|\\b(?:real|true|actual|life)[\\s-]+(?:scale|size)\\b[^.?!]{0,50}\\b' + MUSEUM_WORD,
      'i'
    ),
  },
  {
    key: 'linkAtlas',
    ask: 'askAtlas',
    u: '/pages/atlas',
    re: /\b(?:the|our|airx(?:['’]s)?)\s+(?:artwork\s+)?atlas\b|\bartwork\s+atlas\b|\b(?:every|each)\s+(?:artwork|piece|canvas)\s+(?:we\s+(?:carry|make|have)\s+)?on\s+(?:one|a\s+single)\s+page\b|\ball\s+(?:of\s+)?(?:our|the)\s+(?:artworks|pieces|canvases)\s+on\s+(?:one|a\s+single)\s+page\b/i,
  },
  {
    key: 'linkDescribe',
    ask: 'askDescribe',
    u: DESCRIBE_LINK,
    re: /\bfrom\s+(?:a|your|my|just\s+a)\s+(?:written|text|short|simple|typed)\s+description\b|\b(?:paint|paints|painted|painting|create|creates|generate|generates|make|makes)\s+(?:you\s+)?(?:an?\s+)?(?:original\s+)?(?:artwork|art|painting|piece|one|original)?\s*from\s+(?:a|just\s+a)\s+description\b|\b(?:describe|description)\s+mode\b|\bdescrib(?:e|ing)\s+(?:your|an?|the)\s+(?:idea|scene|vision|subject)\b[^.?!]{0,60}\bstudio\b|\bstudio\b[^.?!]{0,60}\bdescrib(?:e|ing)\s+(?:your|an?|the|what)\b/i,

    skip: /^(?![\s\S]*\bstudio\b)[\s\S]*\b(?:here|this\s+chat)\b/i,
    skipSentence: true,
  },
  {
    key: 'linkRepaint',
    ask: 'askRepaint',
    u: '/pages/ai-art-studio',
    re: /\bai\s+(?:art\s+)?studio\b|\bcreate[\s-]+your[\s-]+own\s+studio\b|\brepaint(?:s|ed|ing)?\s+(?:a|your|my|the|any|an|it|them)\b|\bturn(?:s|ing|ed)?\s+(?:a|your|my|any|an|the)\b[^.?!]{0,60}\b(?:photos?|pictures?|images?|portraits?|shots?)\b[^.?!]{0,60}\binto\b|\bupload(?:s|ing)?\s+(?:a|your|my|any|an)\b[^.?!]{0,30}\b(?:photos?|pictures?|images?)\b/i,
    veto: /\bdescri(?:be|bing|ption)\b/i,
    keep: /\bphotos?\b|\bpictures?\b|\bimages?\b|\brepaint/i,
  },
  {
    key: 'linkPrint',
    ask: 'askPrint',
    u: '/pages/print-your-photo',
    re: /\bprint\s+your\s+photo\b|\bprint(?:s|ed|ing)?\s+(?:it\s+|them\s+)?(?:exactly\s+)?as[\s-]+(?:shot|captured|taken|photographed|is)\b|\bprint(?:s|ed|ing)?\s+(?:it\s+|them\s+)?exactly\s+as\s+(?:you|it|they)\b/i,
    skip: /\bpric(?:e|es|ed|ing)\b|\bcosts?\b|\bsame\s+as\b/i,
  },
  {
    key: 'linkWall',
    ask: 'askWall',
    u: '/pages/design-your-wall',
    re: /\bdesign\s+your\s+wall\b|\bplan(?:s|ned|ning)?\s+(?:a|your|the|out\s+(?:a|your|the))\s+(?:whole|full|entire|complete)\s+wall\b|\b(?:whole|full|entire)[\s-]+wall\s+(?:arrangement|layout|plan)s?\b|\bwall\s+arrangements?\b/i,
  },
];

const REPLY_NEGATION_RE = /\b(?:not|no|never|cannot|unable|unavailable)\b|n['’]t\b/i;
const REPLY_NEGATION_AFTER_RE = /^[\s,]*(?:\S+\s+){0,2}?(?:(?:is|are|was|were|does|do|did|can|could|will|would|has|have)\s+(?:not|never)\b|isn['’]t|aren['’]t|wasn['’]t|weren['’]t|doesn['’]t|don['’]t|didn['’]t|can['’]t|cannot|couldn['’]t|won['’]t|wouldn['’]t|hasn['’]t|haven['’]t|(?:is|are)\s+(?:currently\s+)?(?:unavailable|offline|closed|down))/i;

const REPLY_NEG_EXEMPT_RE = /\b(?:not\s+(?:just|only|merely|simply)|no\s+(?:need|extra|additional|added|guesswork|guessing|measuring|measurements?|frame|framing|tools?|hassle|fuss|minimums?|codes?|cost|charge|problem|worries|wonder|matter|doubt)|why\s+not|(?:don['’]t|do\s+not)\s+(?:miss|forget|hesitate)|never\s+(?:been\s+)?easier)\b/gi;
const REPLY_NEGATION_WINDOW = 6;
const REPLY_CLAUSE_BREAK_RE = /[,;:()—–]|\s-\s|\b(?:but|while|whereas|though|although|however|instead)\b/gi;

const ACTION_OPENER_RE = /\b(?:would|do)\s+you\s+(?:like|want|prefer|rather)\s+(me\s+)?to\b|\bwould\s+you\s+rather\b|\bare\s+you\s+ready\s+to\b|\b(?:shall|should|can|may)\s+i\b|\bwant\s+me\s+to\b|\bi\s+(?:can|could)\b|\bhow\s+about\s+i\b/i;

const ACTION_VERB_RE = /^(?:see|view|explore|browse|check|look|find|show|compare|try|start|pick|choose|select|walk|tour|preview|plan|design|paint|create|make|print|add|get|narrow|focus|keep|go|switch|discover|learn|hear|hang|pair|mix|visit|open|take|build|shop|order|move|shift|stay|stick|continue|dive|pull|put|bring|refine|filter|sort|tell|give|suggest|recommend|line|map|mock|upload|turn|repaint|personali[sz]e|match|flip|resize|size|lean|round|swap|balance|soften|brighten|lighten|anchor|energi[sz]e)\b/i;

const ACTION_CUSTOMER_INPUT_RE = /^(?:tell|share|describe|give|send|upload|measure|let)\b/i;

const YOU_SUBJECT_NEXT_RE = /^(?:are|were|have|had|can|could|will|would|need|needs|want|like|love|loved|liked|prefer|might|may|should|already|currently|plan|imagine|picture|mentioned|described|picked|chose|saw|see|hang|enjoy|choose|pick|feel)\b/i;
const ACTION_MAX_CHARS = 44;
const ACTION_MAX_WORDS = 7;

const ACTION_RESULT_VERB_RE = /^(?:turn|bring|make|move|transform|change|convert|put|shift|switch)\b/i;

const ACTION_COMMERCE_RE = /\b(?:cart|basket|checkout|wish\s*list)\b|^(?:order|buy|purchase)\b|^check\s+out$/i;

const OUR_SHARED_NEXT_RE = /^(?:search|conversation|chat|list|shortlist|selection|options|picks|tour|look)\b/i;

const RANGE_DASH = '\u2012';

const CUSTOM_TEXT_RE = /\bcustom\s+text\b|\bpersonal(?:i[sz]ed)?\s+(?:custom\s+)?(?:text|message|inscription|lettering|wording)\b|\b(?:add|adding)\s+a\s+personal\s+touch\b|\bhand[\s-]?lettered\b|\bpersonal\s+touch\b[^.?!]{0,40}\b(?:text|words|name|message)\b/i;
const PAINT_HERE_RE = /\b(?:i|we)(?:\s+(?:can|could|will|would)|['’](?:ll|d))?\s+(?:also\s+|happily\s+|gladly\s+)?(?:be\s+(?:happy|glad)\s+to\s+)?(?:have\s+(?:\w+\s+){0,2}painted|paint)\b|\bpaint\s+(?:you\s+)?an?\s+original\b|\boriginal(?:\s+(?:painting|piece|artwork))?\s+(?:can\s+be\s+)?(?:painted|made)\s+(?:at|to|for|in|here|right\s+here)\b|\b(?:create|make)\s+(?:one|an?\s+original(?:\s+\w+)?)\s+for\s+you\s+(?:right\s+)?here\b/i;

const PHOTO_LINK_PATHS = ['/pages/ai-art-studio', '/pages/print-your-photo'];

const GENERIC_OPTION_RE = /^(?:mood|moods|place|places|subject|subjects|space|spaces|idea|ideas|thing|things|feeling|feelings|vibe|vibes|theme|themes|direction|directions|option|options|style|styles|look|looks|setting|settings|kind|type|sort)$/i;

const PARTICIPLE_END_RE = /\b(?:made|painted|done|created|printed|repainted|built|designed|framed|shot|taken|drawn|hung|placed|shown|sold|given|seen|chosen|set|kept|left|\w{3,}ed)$/i;
const NOT_PARTICIPLE_RE = /(?:bed|red|shed|sled|need|speed|seed|breed|weed|reed|feed|steed|tweed|bleed|greed)$/i;
const TEASER_IDLE_MS = 25000;
const MAX_FAVORITES = 24;
const MAX_RECENT = 8;

const TYPE_CHARS_PER_SEC = 48;

const PACE_CATCHUP_MS = 220;
const PACE_HIDDEN_MS = 300;
const PACE_HIDDEN_BATCH = 48;

const GREETING_CHARS_PER_SEC = 120;

function paceTick(fn) {
  var raf = 0;
  var timer = 0;
  function cancel() {
    if (raf) { window.cancelAnimationFrame(raf); raf = 0; }
    if (timer) { window.clearTimeout(timer); timer = 0; }
  }
  function run() { cancel(); fn(); }
  raf = window.requestAnimationFrame(run);
  timer = window.setTimeout(run, PACE_HIDDEN_MS);
  return cancel;
}

const FONT_PREF_KEY = 'airx:curator:font';
const MAX_EMAIL = 254;
const MAX_NOTE = 300;
const PREVIEW_DESC_MAX = 300;
const LOUPE_SIZE = 180;
const LOUPE_ZOOM = 2;
const NUDGE_FIRST_AT = 5;
const NUDGE_SECOND_AT = 15;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const AVATAR_REPLY_EVERY = 3;
const AVATAR_REPLY_LIMIT = 3;
const AVATAR_CLICK_RESET_MS = 30000;
const AVATAR_POPOVER_MS = 4200;
const AVATAR_REACTION_MIN_GAP_MS = 180;
const EXCLUDED_COLLECTIONS = { 'new-releases-archive': true, frontpage: true };

const CATEGORY_SUFFIX_RE = /\s*Canvas\s*Wall\s*Art\s*$/i;

const ROOM_IMAGE_RULES = [
  { key: 'bedroom', re: /bed[\s_-]*room/i },
  { key: 'living', re: /living[\s_-]*room/i },
  { key: 'office', re: /office|study|work[\s_-]*space/i },
  { key: 'dining', re: /dining/i },
  { key: 'kitchen', re: /kitchen/i },
  { key: 'gym', re: /gym|fitness|workout/i },
  { key: 'bathroom', re: /bath[\s_-]*room/i },

  { key: 'nursery', re: /nursery|kids|children/i },
  { key: 'hallway', re: /hall[\s_-]*way|entry[\s_-]*way|foyer/i },
];

function normalizeRoom(value) {
  const v = clean(value, 40).toLowerCase();
  if (!v) return '';
  for (const rule of ROOM_IMAGE_RULES) {
    if (rule.key === v || rule.re.test(v)) return rule.key;
  }
  return '';
}

function roomImagesFromListing(images) {
  const map = {};
  let found = false;
  for (const image of Array.isArray(images) ? images : []) {
    const src = image && image.src ? String(image.src) : '';
    if (!src) continue;
    const file = src.split('?')[0].split('/').pop() || '';
    for (const rule of ROOM_IMAGE_RULES) {
      if (!map[rule.key] && rule.re.test(file)) {
        map[rule.key] = src;
        found = true;
      }
    }
  }
  return found ? map : null;
}

function cleanRoomImages(value) {
  if (!value || typeof value !== 'object') return null;
  const out = {};
  let found = false;
  for (const rule of ROOM_IMAGE_RULES) {
    const src = clean(value[rule.key], 1000);
    if (src) {
      out[rule.key] = src;
      found = true;
    }
  }
  return found ? out : null;
}

const ART_SIZE_RE = /(\d+(?:\.\d+)?)\s*L?["″]?\s*[x×]\s*(\d+(?:\.\d+)?)/i;

function parseArtSize(value) {
  const m = String(value == null ? '' : value).match(ART_SIZE_RE);
  return m ? { w: parseFloat(m[1]), h: parseFloat(m[2]) } : null;
}

function parseArtDepth(value) {
  const v = String(value == null ? '' : value);
  if (!/inch/i.test(v)) return null;
  return v.indexOf('3/4') !== -1 ? 0.75 : 1.5;
}

const ART_LIMITS = { minShort: 8, minLong: 10, maxShort: 39, maxLong: 72 };
const ART_DEPTHS = ['3/4 Inch', '1 1/2 Inch'];
const ART_OFFER_RE = /^[A-Za-z0-9._~-]+$/;
const ART_OFFER_MAX = 2000;
const ART_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const ART_SIG_RE = /^[0-9a-f]{16,256}$/i;
const ART_EXP_RE = /^\d{1,12}$/;
const ART_STATES = ['offer', 'painting', 'done', 'error', 'out_of_range'];
const ART_STAGES = ['queued', 'checking', 'painting', 'finishing'];

const ART_ERRORS = {
  paint_limit: { key: 'artErrorLimit', retry: false },
  paint_in_progress: { key: 'artErrorInProgress', retry: true },
  quota_exceeded: { key: 'artErrorCapacity', retry: false },
  busy: { key: 'artErrorBusy', retry: true },
  paint_unavailable: { key: 'artErrorUnavailable', retry: false },
  rejected: { key: 'artErrorRejected', retry: false },
  offer_expired: { key: 'artErrorOffer', retry: false },
  expired: { key: 'artExpired', retry: false },

  job_lost: { key: 'artErrorLost', retry: true },
  generic: { key: 'artErrorGeneric', retry: true },
};
const ART_POLL_MS = 3000;

const ART_POLL_DEADLINE_MS = 10 * 60 * 1000;
const ART_QUEUE_DEADLINE_MS = 35 * 60 * 1000;
const ART_MAX_POLL_FAILS = 4;
const ART_PAINT_TIMEOUT = 15000;

function artRound(n) {
  return Math.round(n * 10) / 10;
}

function artFmt(n) {
  return String(artRound(n));
}

function artNumber(value, min, max) {
  return typeof value === 'number' && Number.isFinite(value) && value >= min && value <= max ? value : null;
}

function artInRange(w, h) {
  const short = Math.min(w, h);
  const long = Math.max(w, h);
  return short >= ART_LIMITS.minShort && short <= ART_LIMITS.maxShort &&
    long >= ART_LIMITS.minLong && long <= ART_LIMITS.maxLong;
}

function artOrient(w, h) {
  return w > h ? 'landscape' : w < h ? 'portrait' : 'square';
}

function artOfferToken(value) {
  return typeof value === 'string' && value.length > 0 && value.length <= ART_OFFER_MAX && ART_OFFER_RE.test(value)
    ? value
    : '';
}

function artDefaultDepth(w, h) {
  return Math.max(w, h) >= 30 ? '1 1/2 Inch' : '3/4 Inch';
}

function artPrice(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const currency = typeof raw.currency === 'string' && /^[A-Z]{3}$/.test(raw.currency) ? raw.currency : '';
  if (!currency) return null;
  const amounts = {};
  const source = raw.amounts && typeof raw.amounts === 'object' && !Array.isArray(raw.amounts) ? raw.amounts : null;
  if (!source) return null;
  for (const depth of ART_DEPTHS) {
    const amount = artNumber(source[depth], 0.01, 100000);
    if (amount != null) amounts[depth] = Math.round(amount * 100) / 100;
  }
  const defaultDepth = ART_DEPTHS.indexOf(raw.defaultDepth) > -1 ? raw.defaultDepth : '';
  if (!defaultDepth || amounts[defaultDepth] == null) return null;
  const tier = typeof raw.tier === 'string' ? clean(raw.tier, 30) : '';
  return {
    currency,
    standard: raw.standard === true,
    tier: tier && /^[A-Za-z0-9 ]+$/.test(tier) ? tier : null,
    defaultDepth,
    amounts,
  };
}

function artLimits(raw) {
  const src = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
  const out = {};
  for (const key of Object.keys(ART_LIMITS)) {
    const n = artNumber(src[key], 1, 1000);
    out[key] = n == null ? ART_LIMITS[key] : artRound(n);
  }
  return out;
}

function artSide(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const w = artNumber(raw.w, 1, 1000);
  const h = artNumber(raw.h, 1, 1000);
  if (w == null || h == null) return null;
  const side = { w: artRound(w), h: artRound(h) };
  if (!artInRange(side.w, side.h)) return null;
  const offer = artOfferToken(raw.offer);
  if (!offer) return null;
  side.orient = artOrient(side.w, side.h);
  side.price = artPrice(raw.price);
  side.offer = offer;
  return side;
}

function artSignedParts(raw, id, kind, serviceUrl) {
  if (typeof raw !== 'string' || raw.length > 2000) return null;
  let parsed = null;
  try {
    const base = new URL(serviceUrl + '/');
    parsed = new URL(raw, base);

    if (parsed.hostname !== base.hostname || parsed.protocol !== base.protocol) return null;
  } catch (err) {
    return null;
  }
  const tail = '/api/curator/art/' + id + '/' + kind;
  if (parsed.pathname.slice(-tail.length).toLowerCase() !== tail) return null;
  const exp = parsed.searchParams.get('exp') || '';
  const sig = parsed.searchParams.get('sig') || '';
  if (!ART_EXP_RE.test(exp) || !ART_SIG_RE.test(sig)) return null;
  return { exp, sig: sig.toLowerCase() };
}

function artResult(raw, serviceUrl) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const id = typeof raw.id === 'string' && ART_UUID_RE.test(raw.id) ? raw.id.toLowerCase() : '';
  if (!id) return null;
  const w = artNumber(raw.w, 1, 1000);
  const h = artNumber(raw.h, 1, 1000);
  if (w == null || h == null || !artInRange(artRound(w), artRound(h))) return null;
  const width = artNumber(raw.width, 16, 20000);
  const height = artNumber(raw.height, 16, 20000);
  const preview = artSignedParts(raw.preview, id, 'preview', serviceUrl);
  const print = artSignedParts(raw.print, id, 'print', serviceUrl);
  if (!preview || !print) return null;
  let expires = artNumber(raw.expires, 1, 1e12);
  if (expires == null) expires = Number(print.exp);
  const base = '/api/curator/art/' + id;
  return {
    id,
    w: artRound(w),
    h: artRound(h),
    width: width == null ? 0 : Math.round(width),
    height: height == null ? 0 : Math.round(height),
    preview: base + '/preview?exp=' + preview.exp + '&sig=' + preview.sig,
    print: base + '/print?exp=' + print.exp + '&sig=' + print.sig,
    expires: Math.floor(expires),
  };
}

function artExpired(art) {
  return !art || !art.expires || art.expires * 1000 <= Date.now();
}

function artElapsed(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
}

function artMoney(amount) {
  const cents = Math.round(amount * 100);
  const text = money(cents);
  return cents % 100 === 0 ? text.replace(/[.,]00(?=\D*$)/, '') : text;
}

const AVATAR_REACTIONS = [
  '👋 Hello, art lover!',
  '🎨 Let\'s find your piece!',
  '✨ Beautiful possibilities!',
  '🌟 Your wall has potential!',
  '🏠 Tell me about the room!',
  '💫 I\'m listening!',
  '🖼️ Let\'s compare artworks!',
  '❤️ Save what speaks to you!',
  '📐 I can help with scale!',
  '🌈 What mood are we creating?',
];

const AVATAR_QUICK_TIPS = [
  'Tell me the room and the feeling you want it to create.',
  'Share one color already in your space for a closer visual match.',
  'Your wall width helps me suggest a balanced canvas size.',
  'Choose a category on the right and I’ll narrow the gallery.',
  'Open a recommendation to see its current sizes, options, and price.',
  'Save favorites while we compare color, scale, and subject.',
  'For a statement wall, tell me how far away it will be viewed.',
  'Try words like calm, bold, warm, minimal, or playful.',
  'Tell me what furniture sits below the art to help with scale.',
  'I can help with AirX artworks and product details.',
];

const AVATAR_CHAT_REPLIES = [
  '👋 I’m right here. Which room are we choosing art for today?',
  '🎨 Tell me the mood you want—calm, bold, warm, playful, or minimal—and I’ll narrow the gallery.',
  '🏠 Describe the wall and one color already in the room. I’ll look for artworks that feel at home there.',
  '📐 Share your wall width and what sits beneath it, and I’ll help you choose a balanced canvas size.',
  '✨ Would you like a statement piece or something quiet? That one choice will sharpen my recommendations.',
  '🖼️ Choose a category on the right, or tell me a subject you love, and I’ll show clickable AirX product options.',
  '❤️ Save any piece that catches you. I can help compare your favorites by color, scale, and feeling.',
  '🌿 If you want a calmer room, I can guide you toward softer palettes and more open compositions.',
  '🔥 If you want energy, tell me the room and its existing colors, and I’ll look for a bolder piece.',
  '🌙 I’m your AirX art and product guide. Ask me about an artwork, size, room fit, or product option.',
];

const SS = {
  opened: 'airx:curator:opened',
  panel: 'airx:curator:panel',
  pulsed: 'airx:curator:pulsed',
  teaser: 'airx:curator:teaser',
  transcript: 'airx:curator:transcript',
  collections: 'airx:curator:collections:v2',
  category: 'airx:curator:cat:v3:',
  nudgeFirst: 'airx:curator:nudge:5',
  nudgeSecond: 'airx:curator:nudge:15',
};

const LS = {
  favorites: 'airx:curator:favorites',
  recent: 'airx:curator:recent',
};

const ssGet = (key) => {
  try { return sessionStorage.getItem(key); } catch (err) { return null; }
};
const ssSet = (key, value) => {
  try { sessionStorage.setItem(key, value); } catch (err) {  }
};
const ssRemove = (key) => {
  try { sessionStorage.removeItem(key); } catch (err) {  }
};
const lsGet = (key) => {
  try { return localStorage.getItem(key); } catch (err) { return null; }
};
const lsSet = (key, value) => {
  try { localStorage.setItem(key, value); } catch (err) {  }
};

function storedProducts(key, max) {
  const raw = lsGet(key);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((item) => item && clean(item.h, 80) && clean(item.t, 120))
      .map((item) => {
        const record = {
          h: clean(item.h, 80),
          t: clean(item.t, 120),
          p: clean(item.p, 80),
          img: clean(item.img, 1000),
          min: Math.max(0, Number(item.min) || 0),
          o: clean(item.o, 30),
          c: clean(item.c, 60),
        };
        const ri = cleanRoomImages(item.ri);
        if (ri) record.ri = ri;
        return record;
      })
      .slice(0, max);
  } catch (err) {
    return [];
  }
}

function clean(value, max) {
  return String(value == null ? '' : value)
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, max);
}

const entityDecodeEl = document.createElement('textarea');
function decodeEntities(value) {
  if (value.indexOf('&') === -1) return value;
  entityDecodeEl.innerHTML = value;
  return entityDecodeEl.value;
}

function titleCase(value) {
  const s = clean(value, 60);
  if (!s || /[A-Z]/.test(s)) return s;
  return s.replace(/(^|[\s-])([a-z])/g, (m, pre, ch) => pre + ch.toUpperCase());
}

function interp(str, vars) {
  return String(str == null ? '' : str).replace(/\[(\w+)\]/g, (m, key) =>
    Object.prototype.hasOwnProperty.call(vars, key) ? vars[key] : m
  );
}

function money(cents) {
  if (AirX && AirX.formatMoney) return AirX.formatMoney(cents);
  return '$' + (cents / 100).toFixed(2);
}

function sized(src, width) {
  return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
}

function cdnImage(src) {
  let value = clean(src, 1000);
  if (!value) return '';
  if (value.indexOf('//') === 0) value = 'https:' + value;
  let parsed = null;
  try { parsed = new URL(value); } catch (err) { return ''; }
  return parsed.protocol === 'https:' && parsed.hostname === 'cdn.shopify.com' ? parsed.href : '';
}

function orientationFromTags(tags) {
  const list = Array.isArray(tags) ? tags : String(tags == null ? '' : tags).split(',');
  for (const raw of list) {
    const tag = String(raw).trim().toLowerCase();
    if (/^(horizontal|vertical|square|panoramic|portrait|landscape)$/.test(tag)) {
      return tag.charAt(0).toUpperCase() + tag.slice(1);
    }
  }
  return '';
}

function fetchJSON(url, timeout, init) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeout || FETCH_TIMEOUT);
  return fetch(url, Object.assign({ credentials: 'same-origin', signal: controller.signal }, init))
    .then((res) => {
      if (!res.ok) {
        const err = new Error('HTTP ' + res.status);
        err.status = res.status;
        throw err;
      }
      return res.json();
    })
    .finally(() => clearTimeout(timer));
}

function compactFromListing(item, collectionTitle) {
  const prices = (item.variants || [])
    .map((v) => parseFloat(v.price))
    .filter((n) => !isNaN(n));
  const min = prices.length ? Math.round(Math.min.apply(null, prices) * 100) : 0;
  const max = prices.length ? Math.round(Math.max.apply(null, prices) * 100) : min;
  const image = (item.images && item.images[0] && item.images[0].src) || '';
  const record = {
    h: clean(item.handle, 80),
    t: clean(item.title, 120),
    p: min === max ? money(min) : money(min) + '–' + money(max),
    o: orientationFromTags(item.tags),
    c: collectionTitle ? clean(collectionTitle, 60) : '',
    img: image,
    min,
  };
  const ri = roomImagesFromListing(item.images);
  if (ri) record.ri = ri;
  return record;
}

function compactFromAjax(product) {
  const min = product.price_min != null ? product.price_min : product.price || 0;
  const max = product.price_max != null ? product.price_max : min;
  const record = {
    h: clean(product.handle, 80),
    t: clean(product.title, 120),
    p: min === max ? money(min) : money(min) + '–' + money(max),
    o: orientationFromTags(product.tags),
    c: '',
    img: product.featured_image || '',
    min,
  };

  const images = [];
  if (Array.isArray(product.media)) {
    for (const media of product.media) {
      if (!media || (media.media_type && media.media_type !== 'image')) continue;
      const src = media.src || (media.preview_image && media.preview_image.src) || '';
      if (src) images.push({ src: String(src) });
    }
  }
  if (!images.length && Array.isArray(product.images)) {
    for (const src of product.images) {
      if (src) images.push({ src: String(src) });
    }
  }
  const ri = roomImagesFromListing(images);
  if (ri) record.ri = ri;
  return record;
}

if (AirX && AirX.DrawerElement && !customElements.get('sales-curator')) {
  class SalesCurator extends AirX.DrawerElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;
      super.connectedCallback();

      this.serviceUrl = (this.dataset.serviceUrl || '').replace(/\/+$/, '');

      if (!/^https:\/\//i.test(this.serviceUrl) &&
          /^(127\.0\.0\.1|localhost)$/.test(window.location.hostname)) {
        this.serviceUrl = 'http://127.0.0.1:8787';
      }

      this.artOrderable = false;
      try {
        const studio = (this.dataset.studioServiceUrl || '').replace(/\/+$/, '');
        this.artOrderable = !!studio && new URL(studio).origin === new URL(this.serviceUrl).origin;
      } catch (err) {
        this.artOrderable = false;
      }
      this.pageType = this.dataset.pageType || '';
      this.loggedIn = this.dataset.loggedIn === 'true';

      this.registerUrl = (this.dataset.registerUrl || '').trim();
      if (!this.serviceUrl) return;

      const stringsEl = this.querySelector('[data-curator-strings]');
      let strings = {};
      try { strings = stringsEl ? JSON.parse(stringsEl.textContent) : {}; } catch (err) { strings = {}; }

      const decodeEl = document.createElement('textarea');
      for (const key of Object.keys(strings)) {
        if (typeof strings[key] === 'string' && strings[key].indexOf('&') !== -1) {
          decodeEl.innerHTML = strings[key];
          strings[key] = decodeEl.value;
        }
      }
      this.strings = strings;

      this.launcher = this.querySelector('[data-curator-launcher]');
      this.teaser = this.querySelector('[data-curator-teaser]');
      this.messagesEl = this.querySelector('[data-curator-messages]');
      this.scrollEl = this.querySelector('[data-curator-scroll]');
      this.chipsEl = this.querySelector('[data-curator-chips]');
      this.catsEl = this.querySelector('[data-curator-cats]');
      this.form = this.querySelector('[data-curator-form]');
      this.input = this.querySelector('[data-curator-input]');
      this.sendBtn = this.querySelector('[data-curator-send]');
      this.statusEl = this.querySelector('[data-curator-status]');
      this.statusText = this.querySelector('[data-curator-status-text]');
      this.launcherStatus = this.querySelector('[data-curator-launcher-status]');
      this.expandBtn = this.querySelector('[data-curator-expand]');
      this.railToggle = this.querySelector('[data-curator-rail-toggle]');
      this.rail = this.querySelector('[data-curator-rail]');
      this.favoritesEl = this.querySelector('[data-curator-favorites]');
      this.favoriteCountEl = this.querySelector('[data-curator-favorite-count]');
      this.recentEl = this.querySelector('[data-curator-recent]');
      this.shortlistEl = this.querySelector('[data-curator-shortlist]');
      this.proTipEl = this.querySelector('[data-curator-pro-tip]');
      this.avatarButtons = Array.from(this.querySelectorAll('[data-curator-avatar]'));
      this.avatarRepliesEl = this.querySelector('[data-curator-avatar-replies]');
      this.avatarLiveEl = this.querySelector('[data-curator-avatar-live]');

      this.artLiveEl = this.querySelector('[data-curator-art-live]');
      this.avatarUrl = clean(this.dataset.avatarUrl, 1000);

      this.transcript = this.restoreTranscript();
      this.activeCategory = null;
      this.activeRoom = '';
      this.collections = [];
      this.productIndex = new Map();
      this.poolCache = new Map();
      this._productCache = new Map();
      this.previewEl = null;
      this.previewEls = null;
      this._preview = null;
      this._previewOpen = false;
      this._previewSeq = 0;
      this._previewReturnScroll = 0;
      this._previewTrigger = null;
      this._previewStatusTimer = null;
      this._previewMode = 'photos';
      this._previewViewer = null;
      this._viewerAssetsPromise = null;
      this._webglBlocked = null;
      this._silentTrapArm = null;
      this._steppingAside = false;
      this.currentProductPromise = null;
      this.streaming = false;
      this.locked = '';
      this._followupSeq = 0;
      this.controller = null;
      this.generation = 0;
      this.firstOpenDone = false;
      this.expanded = false;
      this.favorites = storedProducts(LS.favorites, MAX_FAVORITES);
      this.recent = storedProducts(LS.recent, MAX_RECENT);
      this.reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._externalPromptTimer = null;
      this._pendingExternalPrompt = '';
      this._lastExternalPrompt = { text: '', at: 0 };
      this._errorState = Object.create(null);
      this._healthCheckId = 0;
      this._healthRetryTimer = null;
      this._healthRetryAttempt = 0;
      this._healthFailureCount = 0;
      this.availabilityState = 'checking';
      this._openingFromInvitation = false;
      this._avatarClickCount = 0;
      this._avatarReactionIndex = Math.floor(Math.random() * AVATAR_REACTIONS.length);
      this._avatarTipIndex = Math.floor(Math.random() * AVATAR_QUICK_TIPS.length);
      this._avatarReplyIndex = Math.floor(Math.random() * AVATAR_CHAT_REPLIES.length);
      this._avatarReplyQueue = [];
      this._avatarReplyTyping = false;
      this._avatarLastClickAt = 0;
      this._avatarClickResetTimer = null;
      this._avatarPopoverTimer = null;
      this._avatarWaveTimer = null;
      this._avatarReplyTimer = null;
      this._avatarLiveTimer = null;

      this._artCtls = new Set();
      this._artLiveTimer = null;

      for (const record of this.favorites.concat(this.recent)) {
        this.productIndex.set(record.h, record);
      }

      if (this.pageType === 'collection') {
        const match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
        let handle = match ? match[1] : '';
        try { handle = decodeURIComponent(handle); } catch (err) {  }
        if (handle && handle !== 'all') {
          this.activeCategory = { handle, title: titleCase(handle.replace(/-\d*$/, '').replace(/-/g, ' ')) };
        }
      }

      this.launcher.addEventListener('click', () => {
        if (this.isOpen) {
          this.close();
          return;
        }
        this.setExpanded(false);
        this.open(this.launcher);
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (this.streaming) return;
        const text = this.input.value;
        this.input.value = '';
        this.sendMessage(text);
      });
      const resetBtn = this.querySelector('[data-curator-reset]');
      if (resetBtn) resetBtn.addEventListener('click', () => this.resetConversation());

      const fontToggle = this.querySelector('[data-curator-font-toggle]');
      const applyFontPref = (large) => {
        if (large) this.setAttribute('data-curator-font', 'large');
        else this.removeAttribute('data-curator-font');
        if (fontToggle) fontToggle.setAttribute('aria-pressed', large ? 'true' : 'false');
      };
      applyFontPref(lsGet(FONT_PREF_KEY) === 'large');
      if (fontToggle) fontToggle.addEventListener('click', () => {
        const large = this.getAttribute('data-curator-font') !== 'large';
        applyFontPref(large);
        lsSet(FONT_PREF_KEY, large ? 'large' : 'regular');
      });
      this.addEventListener('click', (e) => {
        const avatar = e.target.closest('[data-curator-avatar]');
        if (avatar) {
          e.preventDefault();
          this.handleAvatarClick(avatar);
          return;
        }
        const suggest = e.target.closest('[data-curator-suggest]');
        if (suggest) {
          e.preventDefault();
          this.fireEvent('suggest', suggest.textContent.trim());
          this.sendMessage(suggest.textContent.trim());
          return;
        }
        const chip = e.target.closest('[data-curator-chip]');
        if (!chip) return;
        const handle = chip.dataset.handle || '';

        this.activeCategory = handle
          ? { handle, title: chip.dataset.title || chip.textContent.trim() }
          : null;
        if (chip.dataset.room) this.setActiveRoom(chip.dataset.room);
        this.fireEvent(chip.dataset.room ? 'room' : 'category',
          chip.dataset.room || chip.dataset.title || chip.textContent.trim());
        this.updateProTip();
        this.sendMessage(chip.dataset.prompt || chip.textContent.trim());
      });
      if (this.expandBtn) {
        this.expandBtn.addEventListener('click', () => this.setExpanded(!this.expanded));
      }
      if (this.railToggle) {
        this.railToggle.addEventListener('click', () => {
          const open = !this.classList.contains('curator--rail-open');
          this.classList.toggle('curator--rail-open', open);
          this.railToggle.setAttribute('aria-expanded', String(open));
        });
      }

      this.addEventListener(
        'keydown',
        (e) => {
          if (e.key !== 'Escape' || !this._previewOpen) return;
          e.preventDefault();
          e.stopPropagation();
          this.closePreview(true);
        },
        true
      );

      this._onDocKeydown = (e) => {
        if (e.key !== 'Escape' || e.defaultPrevented || !this.isOpen || this.contains(e.target)) return;

        const target = e.target instanceof Element ? e.target : null;
        if (target && target.closest('[aria-expanded="true"], [aria-modal="true"], [role="dialog"], .is-open')) return;
        if (document.querySelector('[data-airx-modal]:not([hidden]), [data-airx-detail-modal]:not([hidden])')) return;
        if (this._previewOpen) this.closePreview(false);
        else this.close();
      };
      document.addEventListener('keydown', this._onDocKeydown);

      this._onExternalOpen = (e) => {
        const opener = e.target.closest('[data-curator-open]');
        if (!opener || this.contains(opener)) return;
        e.preventDefault();
        const prompt = clean(opener.dataset.curatorPrompt, MAX_CONTENT);
        this.openFromExternal(opener, prompt);
      };
      this._submitExternalForm = (form) => {
        if (!form || this.contains(form)) return;
        const input = form.querySelector('[data-curator-inline-input]');
        const prompt = clean(input && input.value, MAX_CONTENT);
        if (!prompt) {
          if (input) input.focus();
          return;
        }
        if (this.openFromExternal(form, prompt) && input) input.value = '';
      };
      this._onExternalSubmit = (e) => {
        const form = e.target.closest('[data-curator-inline-form]');
        if (!form || this.contains(form)) return;
        e.preventDefault();
        this._submitExternalForm(form);
      };
      this._onExternalKeydown = (e) => {
        const input = e.target.closest('[data-curator-inline-input]');
        if (!input || this.contains(input) || e.key !== 'Enter' || e.isComposing) return;
        const form = input.closest('[data-curator-inline-form]');
        if (!form) return;
        e.preventDefault();
        this._submitExternalForm(form);
      };
      document.addEventListener('click', this._onExternalOpen);
      document.addEventListener('submit', this._onExternalSubmit);
      document.addEventListener('keydown', this._onExternalKeydown);

      AirX.on('drawer:open', (e) => {
        const id = e.detail && e.detail.id;
        if (id && id !== this.id && this.isOpen) {
          this._steppingAside = true;
          this.close();
          this._steppingAside = false;
        }
      });

      if (window.visualViewport) {
        const vv = window.visualViewport;
        this._onViewport = () => {
          if (!this.isOpen || !this.panel) return;
          const occluded = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
          this.panel.style.setProperty('--curator-kb', occluded + 'px');
        };
        vv.addEventListener('resize', this._onViewport);
        vv.addEventListener('scroll', this._onViewport);
      }

      if (ssGet(SS.opened)) this.launcher.classList.add('curator-launcher--mini');
      this.renderSavedProducts();
      this.updateProTip();
      if (this.pageType === 'product') {
        this.currentProduct().then((record) => {
          if (record) this.rememberRecent(record);
        });
      }
      this.armPulse();
      this.armTeaser();
      this.checkHealth(true);
      this.startHealthHeartbeat();
      this.maybeAutoReopen();

      if (!this.firstOpenDone) this.resumeArtJobsHeadless();
    }

    disconnectedCallback() {
      if (this._onExternalOpen) document.removeEventListener('click', this._onExternalOpen);
      if (this._onExternalSubmit) document.removeEventListener('submit', this._onExternalSubmit);
      if (this._onExternalKeydown) document.removeEventListener('keydown', this._onExternalKeydown);
      if (this._onDocKeydown) document.removeEventListener('keydown', this._onDocKeydown);
      this.clearExternalPrompt();
      this.clearHealthRetry();
      this.stopHealthHeartbeat();
      if (window.visualViewport && this._onViewport) {
        window.visualViewport.removeEventListener('resize', this._onViewport);
        window.visualViewport.removeEventListener('scroll', this._onViewport);
      }
      this.clearAvatarInteraction(true);
      this.abortStream();
      this.clearArtJobs();
    }

    api(path) {
      return this.serviceUrl + path;
    }

    clearHealthRetry() {
      if (this._healthRetryTimer) window.clearTimeout(this._healthRetryTimer);
      this._healthRetryTimer = null;
    }

    scheduleHealthRetry() {
      if (this._healthRetryTimer || !this.isConnected) return;
      const delays = [3000, 8000, 20000, 60000];
      const delay = delays[Math.min(this._healthRetryAttempt, delays.length - 1)];
      this._healthRetryAttempt += 1;
      this._healthRetryTimer = window.setTimeout(() => {
        this._healthRetryTimer = null;
        this.checkHealth(true);
      }, delay);
    }

    startHealthHeartbeat() {
      if (this._healthHeartbeat) return;
      this._healthHeartbeat = window.setInterval(() => {
        if (document.hidden || this._healthRetryTimer) return;
        this.checkHealth(true);
      }, HEALTH_HEARTBEAT_MS);
      this._onVisibilityHealth = () => {
        if (document.hidden || this._healthRetryTimer) return;
        const last = window.__airxCuratorAvailability;
        if (!last || Date.now() - last.at >= HEALTH_HEARTBEAT_MS) this.checkHealth(true);
      };
      document.addEventListener('visibilitychange', this._onVisibilityHealth);
    }

    stopHealthHeartbeat() {
      if (this._healthHeartbeat) window.clearInterval(this._healthHeartbeat);
      this._healthHeartbeat = null;
      if (this._onVisibilityHealth) document.removeEventListener('visibilitychange', this._onVisibilityHealth);
      this._onVisibilityHealth = null;
    }

    clearExternalPrompt() {
      if (this._externalPromptTimer) window.clearTimeout(this._externalPromptTimer);
      this._externalPromptTimer = null;
      this._pendingExternalPrompt = '';
    }

    openFromExternal(opener, rawPrompt) {
      const prompt = clean(rawPrompt, MAX_CONTENT);
      const expanded = !opener || opener.dataset.curatorMode !== 'drawer';
      const invitation = opener && opener.closest ? opener.closest('curator-invitation') : null;
      if (invitation && typeof invitation.completeGreeting === 'function') invitation.completeGreeting();
      this._openingFromInvitation = !!invitation;
      try {
        this.setExpanded(expanded);
        if (!this.isOpen) this.open(opener || this.launcher);
      } finally {
        this._openingFromInvitation = false;
      }
      if (!prompt) return true;

      const now = Date.now();
      const duplicate = prompt === this._pendingExternalPrompt || (
        prompt === this._lastExternalPrompt.text && now - this._lastExternalPrompt.at < 1200
      );
      if (duplicate) return true;

      this.clearExternalPrompt();
      this._pendingExternalPrompt = prompt;
      this._lastExternalPrompt = { text: prompt, at: now };

      if (this.streaming) {
        if (this.input && !this.input.value.trim()) this.input.value = prompt;
        this._pendingExternalPrompt = '';
        if (this.input) this.input.focus({ preventScroll: true });
        return true;
      }

      const delay = this.reducedMotion ? 0 : 220;
      this._externalPromptTimer = window.setTimeout(() => {
        this._externalPromptTimer = null;
        const queued = this._pendingExternalPrompt;
        this._pendingExternalPrompt = '';
        if (!queued || !this.isOpen) return;
        if (!this.sendMessage(queued) && this.input && !this.input.value.trim()) {
          this.input.value = queued;
          this.input.focus({ preventScroll: true });
        }
      }, delay);
      return true;
    }

    open(trigger) {
      super.open(trigger);
      if (!this.isOpen) return;
      this.launcher.setAttribute('aria-expanded', 'true');
      this.launcher.classList.add('curator-launcher--mini');
      this.launcher.classList.remove('is-pulsing');
      this.hideTeaser(false);
      ssSet(SS.opened, '1');
      ssSet(SS.panel, '1');
      if (!this.firstOpenDone) {
        this.firstOpenDone = true;
        this.bootConversation();
      } else {
        this.checkHealth(true);
      }
      if (this.input) this.input.focus({ preventScroll: true });
    }

    close() {
      if (!this.isOpen) return;
      this.clearExternalPrompt();
      this.clearAvatarInteraction(true);
      this.closePreview(false);
      if (this._silentTrapArm) {
        this.panel.removeEventListener('focusin', this._silentTrapArm);
        this._silentTrapArm = null;
        this.panel.setAttribute('aria-modal', 'true');
      }

      if (!this._steppingAside) ssRemove(SS.panel);
      super.close();

      const active = document.activeElement;
      if (
        !active ||
        active === document.body ||
        active === document.documentElement ||
        (this.panel && this.panel.contains(active))
      ) {
        this.launcher.focus({ preventScroll: true });
      }
      this.launcher.setAttribute('aria-expanded', 'false');
      if (this.panel) this.panel.style.removeProperty('--curator-kb');
      this.abortStream();
    }

    maybeAutoReopen() {
      if (ssGet(SS.panel) !== '1' || !this.transcript.length) return;
      if (window.Shopify && window.Shopify.designMode) return;
      if (String(this.dataset.template || '').indexOf('gallery-3d') > -1) return;
      this.openSilently();
    }

    openSilently() {
      if (!this.panel || this.isOpen) return;
      this.classList.add('curator--instant');
      if (this.messagesEl) this.messagesEl.setAttribute('aria-live', 'off');
      this.panel.classList.add('is-open');
      this.panel.setAttribute('aria-hidden', 'false');

      this.panel.setAttribute('aria-modal', 'false');
      AirX.overlayOpened(this.id);
      AirX.emit('drawer:open', { id: this.id, drawer: this });
      this.launcher.setAttribute('aria-expanded', 'true');
      this.launcher.classList.add('curator-launcher--mini');
      this.launcher.classList.remove('is-pulsing');
      this.hideTeaser(false);
      ssSet(SS.opened, '1');
      ssSet(SS.panel, '1');
      if (!this.firstOpenDone) {
        this.firstOpenDone = true;
        this.bootConversation();
      }
      this.armSilentFocusTrap();
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          this.classList.remove('curator--instant');
          if (this.messagesEl) this.messagesEl.setAttribute('aria-live', 'polite');
        });
      });
    }

    armSilentFocusTrap() {
      if (this._silentTrapArm) return;
      const arm = (e) => {
        this.panel.removeEventListener('focusin', arm);
        this._silentTrapArm = null;
        this.panel.setAttribute('aria-modal', 'true');
        if (this.isOpen) AirX.trapFocus(this.panel, e.target);
      };
      this._silentTrapArm = arm;
      this.panel.addEventListener('focusin', arm);
    }

    setExpanded(expanded) {
      this.expanded = !!expanded;
      this.classList.toggle('curator--expanded', this.expanded);
      if (this.panel) this.panel.classList.toggle('curator__panel--expanded', this.expanded);
      if (this.expandBtn) {
        this.expandBtn.setAttribute('aria-pressed', String(this.expanded));
        this.expandBtn.setAttribute(
          'aria-label',
          this.expanded ? this.strings.minimize || 'Return to side panel' : this.strings.expand || 'Expand curator'
        );
        const label = this.expandBtn.querySelector('[data-curator-expand-label]');
        if (label) label.textContent = this.expanded ? this.strings.minimize || 'Minimize' : this.strings.expand || 'Expand';
      }
      if (!this.expanded) {
        this.classList.remove('curator--rail-open');
        if (this.railToggle) this.railToggle.setAttribute('aria-expanded', 'false');
      }
      window.requestAnimationFrame(() => this.scrollToEnd(true));
    }

    bootConversation() {
      if (this.transcript.length || this._openingFromInvitation) this.renderBubble('bot', this.strings.greeting || '');
      else this.renderPacedGreeting(this.strings.greeting || '');
      let transcriptCleaned = false;

      this.stopHeadlessArt();

      for (const entry of this.transcript) {
        if (entry.r !== 'a' || !entry.art) continue;
        const art = this.sanitizeStoredArt(entry.art);
        transcriptCleaned = true;
        if (art) entry.art = art;
        else delete entry.art;
      }
      this.supersedeArtEntries(this.transcript);
      for (const entry of this.transcript) {
        if (entry.r === 'a' && /\[\[[^\]]+\]\]/.test(entry.c || '')) {
          entry.c = String(entry.c).replace(/\s*\[\[[^\]]+\]\]/g, '').trim();
          transcriptCleaned = true;
        }
        const el = this.renderBubble(entry.r === 'u' ? 'user' : 'bot', entry.c);
        let anchor = el;
        if (entry.k && entry.k.length) anchor = this.renderCards(entry.k, el) || el;

        if (entry.g) {
          const guideEl = this.renderBubble('bot', entry.g);
          if (guideEl) { guideEl.classList.add('curator__msg--guide'); anchor = guideEl; }
        }

        if (entry.r === 'a' && entry.art) anchor = this.renderArtCard(entry, anchor, true).el;

        if (entry.ln && entry.ln.length) this.renderLinks(entry.ln, anchor);
        if (entry.sg && entry.sg.length) this.renderSuggests(entry.sg, anchor);

        if (entry.r === 'a' && entry.f === 1) this.renderFollowupCard(entry, anchor);
      }
      if (transcriptCleaned) this.saveTranscript();
      this.updateChipsVisibility();
      this.loadCategoryChips();
      this.checkHealth(true);
    }

    renderPacedGreeting(text) {
      this.cancelGreetingTimer();
      const bubble = this.renderBubble('bot', '');
      const value = String(text || '');
      if (!value || this.reducedMotion) {
        this.setBubbleText(bubble, value);
        this._pacedGreeting = null;
        return;
      }
      bubble.setAttribute('aria-live', 'off');
      const state = { bubble, value };
      this._pacedGreeting = state;

      let cursor = 0;
      let credit = 0;
      let lastAt = 0;
      let holdUntil = 0;
      const step = () => {
        this._greetingTimer = null;
        if (!bubble.isConnected || this._pacedGreeting !== state) return;
        const now = performance.now();
        if (document.hidden) {
          cursor = value.length;
          this.setBubbleText(bubble, value);
        } else if (now >= holdUntil) {
          if (!lastAt) lastAt = now;
          credit += (Math.min(now - lastAt, PACE_CATCHUP_MS) / 1000) * GREETING_CHARS_PER_SEC;
          lastAt = now;
          let n = Math.min(Math.floor(credit), value.length - cursor);
          if (n > 1) {
            const brk = value.slice(cursor, cursor + n).search(/[.!?\n]/);
            if (brk >= 0) n = brk + 1;
          }
          if (n > 0) {
            credit -= n;
            cursor += n;
            this.setBubbleText(bubble, value.slice(0, cursor));

            const ch = value.charAt(cursor - 1);
            const hold = /[.!?]/.test(ch) ? 150 : /[,;:]/.test(ch) ? 70 : 0;
            if (hold) {
              holdUntil = now + hold;
              credit = 0;
              lastAt = 0;
            }
          }
        }
        if (cursor >= value.length) {
          bubble.removeAttribute('aria-live');
          this._pacedGreeting = null;
          return;
        }
        this._greetingTimer = paceTick(step);
      };
      const lead = window.setTimeout(() => { this._greetingTimer = paceTick(step); }, 180);
      this._greetingTimer = () => window.clearTimeout(lead);
    }

    cancelGreetingTimer() {
      if (this._greetingTimer) this._greetingTimer();
      this._greetingTimer = null;
    }

    completePacedGreeting() {
      const state = this._pacedGreeting;
      if (!state) return;
      this.cancelGreetingTimer();
      this._pacedGreeting = null;
      if (!state.bubble || !state.bubble.isConnected) return;
      this.setBubbleText(state.bubble, state.value);
      state.bubble.removeAttribute('aria-live');
    }

    handleAvatarClick(button) {
      if (!button || !this.isOpen) return;
      this.completePacedGreeting();
      this.waveAvatar(button);

      const now = Date.now();
      if (now - this._avatarLastClickAt < AVATAR_REACTION_MIN_GAP_MS) return;
      this._avatarLastClickAt = now;

      if (this.streaming) {
        this.showAvatarPopover(button, '✨ I’m thinking…', 'I’ll finish this artwork recommendation first.');
        return;
      }

      this._avatarClickCount += 1;
      const reaction = AVATAR_REACTIONS[this._avatarReactionIndex % AVATAR_REACTIONS.length];
      const tip = AVATAR_QUICK_TIPS[this._avatarTipIndex % AVATAR_QUICK_TIPS.length];
      this._avatarReactionIndex += 1;
      this._avatarTipIndex += 1;
      this.showAvatarPopover(button, reaction, tip);

      if (this._avatarClickResetTimer) window.clearTimeout(this._avatarClickResetTimer);
      this._avatarClickResetTimer = window.setTimeout(() => {
        this._avatarClickCount = 0;
        this._avatarClickResetTimer = null;
      }, AVATAR_CLICK_RESET_MS);

      if (this._avatarClickCount % AVATAR_REPLY_EVERY === 0) {
        const reply = AVATAR_CHAT_REPLIES[this._avatarReplyIndex % AVATAR_CHAT_REPLIES.length];
        this._avatarReplyIndex += 1;
        this.queueAvatarReply(reply);
      }
    }

    waveAvatar(button) {
      if (this.reducedMotion) return;
      for (const avatar of this.avatarButtons) avatar.classList.remove('is-reacting');

      void button.offsetWidth;
      button.classList.add('is-reacting');
      if (this._avatarWaveTimer) window.clearTimeout(this._avatarWaveTimer);
      this._avatarWaveTimer = window.setTimeout(() => {
        for (const avatar of this.avatarButtons) avatar.classList.remove('is-reacting');
        this._avatarWaveTimer = null;
      }, 1150);
    }

    showAvatarPopover(button, reaction, tip) {
      for (const current of this.querySelectorAll('[data-curator-avatar-popover]')) current.remove();
      if (this._avatarPopoverTimer) window.clearTimeout(this._avatarPopoverTimer);

      const popover = document.createElement('span');
      popover.className = 'curator__avatar-popover';
      popover.dataset.curatorAvatarPopover = '';
      popover.setAttribute('aria-hidden', 'true');

      const headline = document.createElement('strong');
      headline.className = 'curator__avatar-popover-reaction';
      headline.textContent = reaction;
      const guidance = document.createElement('span');
      guidance.className = 'curator__avatar-popover-tip';
      guidance.textContent = tip;
      popover.append(headline, guidance);
      button.appendChild(popover);

      this.announceAvatar(reaction + ' ' + tip);
      this._avatarPopoverTimer = window.setTimeout(() => {
        if (popover.isConnected) popover.remove();
        this._avatarPopoverTimer = null;
      }, AVATAR_POPOVER_MS);
    }

    queueAvatarReply(text) {
      const value = clean(text, 320);
      if (!value) return;

      if (this._avatarReplyQueue.length < 2) this._avatarReplyQueue.push(value);
      this.drainAvatarReplies();
    }

    drainAvatarReplies() {
      if (this._avatarReplyTyping || this.streaming || !this.isOpen || !this._avatarReplyQueue.length) return;
      const text = this._avatarReplyQueue.shift();
      this.renderAvatarReply(text);
    }

    renderAvatarReply(text) {
      if (!this.avatarRepliesEl) return;
      while (this.avatarRepliesEl.children.length >= AVATAR_REPLY_LIMIT) {
        this.avatarRepliesEl.firstElementChild.remove();
      }

      const row = document.createElement('div');
      row.className = 'curator__mascot-reply';
      row.dataset.curatorAvatarReply = '';
      row.setAttribute('aria-hidden', 'true');

      if (this.avatarUrl) {
        const image = document.createElement('img');
        image.className = 'curator__mascot-reply-avatar';
        image.src = this.avatarUrl;
        image.alt = '';
        image.width = 34;
        image.height = 34;
        row.appendChild(image);
      }

      const bubble = document.createElement('div');
      bubble.className = 'curator__msg curator__msg--bot curator__msg--mascot';
      bubble.setAttribute('aria-busy', 'true');
      row.appendChild(bubble);
      this.avatarRepliesEl.appendChild(row);
      this.avatarRepliesEl.hidden = false;
      this._avatarReplyTyping = true;
      this.scrollToEnd(true);

      const finish = () => {
        bubble.textContent = text;
        bubble.classList.remove('is-typing');
        bubble.setAttribute('aria-busy', 'false');
        this._avatarReplyTyping = false;
        this.announceAvatar(text);
        this.scrollToEnd(true);
        this._avatarReplyTimer = window.setTimeout(() => {
          this._avatarReplyTimer = null;
          this.drainAvatarReplies();
        }, this.reducedMotion ? 0 : 220);
      };

      if (this.reducedMotion) {
        finish();
        return;
      }

      bubble.classList.add('is-typing');
      const tokens = text.match(/\S+\s*/g) || [text];
      let index = 0;
      bubble.textContent = '';
      const revealNext = () => {
        if (!bubble.isConnected || !this._avatarReplyTyping) return;
        const token = tokens[index];
        bubble.appendChild(document.createTextNode(token));
        index += 1;
        this.scrollToEnd();
        if (index >= tokens.length) {
          finish();
          return;
        }
        const word = token.trim();
        const delay = /[.!?][”’"']?$/.test(word)
          ? 190
          : /[,;:][”’"']?$/.test(word)
            ? 125
            : 62 + Math.round(Math.random() * 34);
        this._avatarReplyTimer = window.setTimeout(revealNext, delay);
      };
      this._avatarReplyTimer = window.setTimeout(revealNext, 180);
    }

    announceAvatar(text) {
      if (!this.avatarLiveEl) return;
      if (this._avatarLiveTimer) window.clearTimeout(this._avatarLiveTimer);
      this.avatarLiveEl.textContent = '';
      this._avatarLiveTimer = window.setTimeout(() => {
        if (this.avatarLiveEl) this.avatarLiveEl.textContent = text;
        this._avatarLiveTimer = null;
      }, 30);
    }

    clearAvatarInteraction(removeReplies) {
      const timers = [
        '_avatarClickResetTimer',
        '_avatarPopoverTimer',
        '_avatarWaveTimer',
        '_avatarReplyTimer',
        '_avatarLiveTimer',
      ];
      for (const key of timers) {
        if (this[key]) window.clearTimeout(this[key]);
        this[key] = null;
      }
      this._avatarClickCount = 0;
      this._avatarLastClickAt = 0;
      this._avatarReplyTyping = false;
      this._avatarReplyQueue = [];
      for (const popover of this.querySelectorAll('[data-curator-avatar-popover]')) popover.remove();
      for (const avatar of this.avatarButtons || []) avatar.classList.remove('is-reacting');
      if (this.avatarLiveEl) this.avatarLiveEl.textContent = '';
      if (removeReplies && this.avatarRepliesEl) {
        this.avatarRepliesEl.textContent = '';
        this.avatarRepliesEl.hidden = true;
      }
    }

    async checkHealth() {
      const checkId = ++this._healthCheckId;
      this.clearHealthRetry();
      if (!window.__airxCuratorAvailability) this.setOnline(null);
      try {
        const health = await fetchJSON(this.api('/api/health'), HEALTH_TIMEOUT, { credentials: 'omit' });
        const chat = health && health.chat;
        const ready = !!health && (chat == null || chat.ready !== false);
        if (checkId === this._healthCheckId) {
          if (ready) {
            this.setOnline(true);
            this._healthRetryAttempt = 0;
            this._healthFailureCount = 0;
          } else {
            this._healthFailureCount += 1;
            this.setOnline(this._healthFailureCount >= 2 ? false : null);
            this.scheduleHealthRetry();
          }
        }
      } catch (err) {
        if (checkId === this._healthCheckId) {
          this._healthFailureCount += 1;
          this.setOnline(this._healthFailureCount >= 2 ? false : null);
          this.scheduleHealthRetry();
        }
      }
    }

    setOnline(state) {
      const statusState = state == null ? 'checking' : state ? 'online' : 'offline';
      this.availabilityState = statusState;
      if (statusState === 'online') this._healthFailureCount = 0;

      if (this.statusEl) this.statusEl.dataset.state = statusState;
      if (this.statusText) {
        this.statusText.textContent = statusState === 'checking'
          ? this.strings.statusChecking || 'Checking availability…'
          : statusState === 'online'
            ? this.strings.statusOnline || ''
            : this.strings.statusOffline || '';
      }

      if (this.launcherStatus) {
        this.launcherStatus.dataset.state = statusState;
        const label = statusState === 'online'
          ? this.launcherStatus.dataset.onlineText
          : statusState === 'offline'
            ? this.launcherStatus.dataset.offlineText
            : this.launcherStatus.dataset.checkingText;
        this.launcherStatus.textContent = label || (this.statusText ? this.statusText.textContent : '');
      }

      document.querySelectorAll('[data-curator-inline-status]').forEach((status) => {
        status.dataset.state = statusState;
        const text = status.querySelector('[data-curator-inline-status-text]');
        if (text) {
          const label = statusState === 'online'
            ? status.dataset.onlineText
            : statusState === 'offline'
              ? status.dataset.offlineText
              : status.dataset.checkingText;
          text.textContent = label || (statusState === 'online'
            ? this.strings.statusOnline || 'Online'
            : statusState === 'offline'
              ? this.strings.statusOffline || 'Offline'
              : this.strings.statusChecking || 'Checking availability…');
        }
      });

      const availability = { state: statusState, at: Date.now() };
      window.__airxCuratorAvailability = availability;
      document.dispatchEvent(new CustomEvent('airx:curator:availability', { detail: availability }));
    }

    updateChipsVisibility() {
      const hasUserMessage = this.transcript.some((m) => m.r === 'u');
      this.chipsEl.hidden = hasUserMessage;
    }

    async loadCategoryChips() {
      const categoryTargets = Array.from(this.querySelectorAll('[data-curator-cats]'));
      if (!categoryTargets.length || categoryTargets.every((target) => target.childElementCount)) return;
      let list = null;
      const cached = ssGet(SS.collections);
      if (cached) {
        try { list = JSON.parse(cached); } catch (err) { list = null; }
      }
      if (!list) {
        try {
          const data = await fetchJSON('/collections.json?limit=250', FETCH_TIMEOUT);
          list = (data.collections || [])
            .filter((c) => c.handle && !EXCLUDED_COLLECTIONS[c.handle])
            .filter((c) => c.products_count == null || c.products_count >= CHIP_MIN_PRODUCTS)
            .slice(0, CHIP_COUNT)
            .map((c) => ({ h: clean(c.handle, 80), t: titleCase(c.title) }));
          ssSet(SS.collections, JSON.stringify(list));
        } catch (err) {
          return;
        }
      }
      this.collections = list;
      for (const target of categoryTargets) {
        if (target.childElementCount) continue;
        const frag = document.createDocumentFragment();
        for (const col of list) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = target.closest('.curator__rail') ? 'curator__rail-choice' : 'curator__chip';
          btn.dataset.curatorChip = '';
          btn.dataset.handle = col.h;
          btn.dataset.title = col.t;
          btn.dataset.prompt = 'Show me ' + col.t + ' artworks';

          const short = col.t.replace(CATEGORY_SUFFIX_RE, '').trim() || col.t;
          btn.textContent = short;
          if (short !== col.t) btn.setAttribute('aria-label', col.t);
          frag.appendChild(btn);
        }
        target.appendChild(frag);
      }
    }

    detectCategory(text) {
      const lower = ' ' + text.toLowerCase() + ' ';
      for (const col of this.collections) {
        const title = col.t.toLowerCase();
        if (title.length >= 4 && lower.indexOf(title) > -1) {
          this.activeCategory = { handle: col.h, title: col.t };
          return;
        }
      }
    }

    sendMessage(rawText) {
      this.cancelRevealTour();
      if (this.streaming || this.locked) return false;
      const text = clean(rawText, MAX_CONTENT);
      if (!text) return false;
      this.closePreview(false);

      this.clearAvatarInteraction(true);
      this.detectCategory(text);
      this.transcript.push({ r: 'u', c: text });
      this.renderBubble('user', text);
      this.saveTranscript();
      this.updateChipsVisibility();
      this.streamReply();
      return true;
    }

    async streamReply() {
      this.streaming = true;
      this.sendBtn.disabled = true;
      const gen = this.generation;
      const typing = this.renderTyping();
      const controller = new AbortController();
      this.controller = controller;
      let deadlineHit = false;
      const deadline = setTimeout(() => {
        deadlineHit = true;
        controller.abort();
      }, STREAM_TIMEOUT);

      let bubble = null;
      let content = '';
      let recommend = null;
      let serverCards = null;
      let serverLinks = null;
      let serverPaint = null;
      let followup = false;
      let doneRoom = '';
      let streamError = '';
      let visibleChars = 0;
      let streamComplete = false;
      let paceResolve = null;

      let paceCancel = null;
      let paceCredit = 0;
      let paceLastAt = 0;
      let paceHoldUntil = 0;

      const ensureBubble = () => {
        if (!bubble) {
          bubble = typing;
          bubble.classList.remove('curator__msg--typing');

          bubble.setAttribute('aria-live', 'off');
          bubble.textContent = '';
        }
        return bubble;
      };

      const resolvePacing = () => {
        if (!paceResolve) return;
        const resolve = paceResolve;
        paceResolve = null;
        resolve();
      };

      const visibleContent = () => {
        const markerAt = content.indexOf('[[');
        return markerAt === -1 ? content : content.slice(0, markerAt);
      };

      const clearPace = () => {
        if (paceCancel) paceCancel();
        paceCancel = null;
      };
      const schedulePace = () => {
        clearPace();
        paceCancel = paceTick(pace);
      };

      const pace = () => {
        clearPace();
        if (controller.signal.aborted || gen !== this.generation) {
          resolvePacing();
          return;
        }
        const target = visibleContent();
        const remaining = target.length - visibleChars;
        if (remaining <= 0) {

          paceLastAt = 0;
          paceCredit = 0;
          if (streamComplete) resolvePacing();
          return;
        }
        ensureBubble();

        if (this.reducedMotion) {
          visibleChars = target.length;
          this.setBubbleText(bubble, target);
          if (streamComplete) resolvePacing();
          return;
        }

        const now = performance.now();

        if (document.hidden) {
          visibleChars = Math.min(target.length, visibleChars + PACE_HIDDEN_BATCH);
          this.setBubbleText(bubble, target.slice(0, visibleChars));
          paceLastAt = 0;
          paceCredit = 0;
          paceHoldUntil = 0;
          if (visibleChars >= target.length && streamComplete) resolvePacing();
          else schedulePace();
          return;
        }

        if (now >= paceHoldUntil) {

          if (!paceLastAt) paceLastAt = now;
          paceCredit += (Math.min(now - paceLastAt, PACE_CATCHUP_MS) / 1000) * TYPE_CHARS_PER_SEC;
          paceLastAt = now;
          let step = Math.min(Math.floor(paceCredit), remaining);
          if (step > 1) {

            const brk = target.slice(visibleChars, visibleChars + step).search(/[.!?\n]/);
            if (brk >= 0) step = brk + 1;
          }
          if (step > 0) {
            paceCredit -= step;
            visibleChars += step;
            this.setBubbleText(bubble, target.slice(0, visibleChars));
            const ch = target.charAt(visibleChars - 1);
            const hold = /[.!?]/.test(ch) ? 145 : /[,;:]/.test(ch) ? 65 : ch === '\n' ? 95 : 0;
            if (hold) {
              paceHoldUntil = now + hold;
              paceCredit = 0;
              paceLastAt = 0;
            }
          }
        }

        if (visibleChars >= target.length && streamComplete) {
          resolvePacing();
          return;
        }
        schedulePace();
      };

      const queuePacing = () => {
        ensureBubble();
        if (!paceCancel) pace();
      };

      const finishPacing = () => {
        streamComplete = true;
        const target = visibleContent();
        if (!target || visibleChars >= target.length || this.reducedMotion) {
          if (target) {
            ensureBubble();
            visibleChars = target.length;
            this.setBubbleText(bubble, target);
          }
          return Promise.resolve();
        }
        return new Promise((resolve) => {
          paceResolve = resolve;
          if (!paceCancel) pace();
        });
      };

      this._cancelPacing = () => {
        clearPace();
        resolvePacing();
      };

      let replyCommitted = false;
      const commitReply = (finalRecommend, finalCards, finalFollowup, finalLinks, finalPaint) => {
        if (replyCommitted) return;
        replyCommitted = true;

        if (doneRoom) this.setActiveRoom(doneRoom);
        this.finalizeReply(typing, bubble, content, finalRecommend, finalCards, finalFollowup, finalLinks, finalPaint);
      };

      try {
        const context = await this.buildContext();
        const messages = this.transcript.slice(-MAX_MESSAGES).map((m) => ({
          role: m.r === 'u' ? 'user' : 'assistant',
          content: m.c.slice(0, MAX_CONTENT),
        }));

        const res = await fetch(this.api('/api/chat'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'omit',
          signal: controller.signal,
          body: JSON.stringify({ messages, context }),
        });

        if (!res.ok || !res.body) {

          let code = '';
          try {
            const data = await res.json();
            if (data && typeof data.error === 'string') code = data.error;
          } catch (jsonErr) {  }
          const err = new Error('HTTP ' + res.status);
          err.status = res.status;
          err.code = code;
          throw err;
        }
        this.setOnline(true);

        const reader = res.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        for (;;) {
          const { done, value } = await reader.read();
          if (done) break;
          buffer += decoder.decode(value, { stream: true });
          let sep;
          while ((sep = buffer.indexOf('\n\n')) > -1) {
            const block = buffer.slice(0, sep);
            buffer = buffer.slice(sep + 2);
            for (const line of block.split('\n')) {
              if (line.slice(0, 5) !== 'data:') continue;
              let payload = null;
              try { payload = JSON.parse(line.slice(5).trim()); } catch (err) { continue; }
              if (payload == null) continue;
              if (typeof payload.delta === 'string' && payload.delta) {
                content += payload.delta;
                queuePacing();
              }
              if (payload.done) {
                recommend = Array.isArray(payload.recommend) ? payload.recommend : [];

                serverCards = Array.isArray(payload.cards) ? payload.cards : null;

                serverLinks = Array.isArray(payload.links) ? payload.links : null;

                followup = payload.followup === true;

                if (typeof payload.room === 'string') doneRoom = payload.room;

                serverPaint = payload.paint && typeof payload.paint === 'object' ? payload.paint : null;
              }
              if (payload.error) streamError = String(payload.error);
            }
          }
        }

        if (!content && streamError) throw new Error(streamError);
        await finishPacing();
        if (controller.signal.aborted) throw new DOMException('Aborted', 'AbortError');
        if (gen === this.generation) {
          commitReply(recommend, serverCards, followup, serverLinks, serverPaint);
          delete this._errorState.chat;
          if (streamError) {

            this.renderErrorOnce(this.strings.errorOffline || '', 'chat');
            this.checkHealth(true);
          }
        } else {
          typing.remove();
        }
      } catch (err) {
        clearPace();
        const aborted = err && err.name === 'AbortError';

        const intentional = aborted && !deadlineHit;

        const lockCode = err && (err.code === 'banned' || err.code === 'daily_limit') ? err.code : '';
        if (gen !== this.generation) {
          typing.remove();
        } else if (lockCode) {
          typing.remove();
          this.lockComposer(lockCode);
        } else if (intentional) {

          typing.remove();
        } else if (content) {

          commitReply(null, null, false);
          this.renderErrorOnce(this.strings.errorOffline || '', 'chat');
        } else {
          typing.remove();
          this.renderErrorOnce(this.strings.errorOffline || '', 'chat');
        }
        if (!intentional && !lockCode && gen === this.generation) this.checkHealth(true);
      } finally {
        clearPace();
        if (this._cancelPacing) this._cancelPacing = null;
        clearTimeout(deadline);
        this.controller = null;
        this.streaming = false;
        this.sendBtn.disabled = !!this.locked;

        if (gen === this.generation && !this.locked && replyCommitted) this.maybeShowRegisterNudge();
      }
    }

    finalizeReply(typing, bubble, content, recommend, serverCards, followup, links, paint) {

      const fallback = this.serverCardRecords(serverCards);

      const art = this.validPaint(paint);
      const autostart = !!(art && art.autostart);
      if (art) delete art.autostart;
      const recovered = this.recoverRecommendations(content, recommend, fallback);
      content = recovered.text;
      recommend = recovered.handles;
      const cards = [];
      if (recommend && recommend.length) {
        for (const handle of recommend) {

          const record = this.productIndex.get(handle) || fallback.get(handle);
          if (record) {
            this.productIndex.set(record.h, record);

            cards.push({ h: record.h, t: record.t, p: record.p, img: this.roomAwareImg(record), min: record.min, o: record.o, c: record.c });
          }
          if (cards.length >= MAX_CARDS) break;
        }
      }
      if (!content && !cards.length && !followup && !art) {
        typing.remove();
        return;
      }

      const text = content
        || (cards.length
          ? this.strings.recommendationsLabel || ''
          : art && !followup
            ? this.strings.artFallback || ''
            : this.strings.followupPrompt || '');
      if (!bubble) {
        bubble = typing;
        bubble.classList.remove('curator__msg--typing');
      }

      bubble.removeAttribute('aria-live');

      const linkChips = this.replyLinks(text, links);
      const suggests = this.deriveSuggests(text, cards, { links: linkChips, art: !!art });
      const split = cards.length ? this.splitGuide(text) : null;
      this.setBubbleText(bubble, split ? split.body : text);
      const entry = { r: 'a', c: (split ? split.body : text).slice(0, MAX_CONTENT) };
      let anchor = bubble;
      if (cards.length) {
        entry.k = cards;
        anchor = this.renderCards(cards, bubble) || bubble;
      }
      if (split) {
        entry.g = split.guide;
        const guideEl = this.renderBubble('bot', split.guide);
        if (guideEl) {
          guideEl.classList.add('curator__msg--guide');
          anchor = guideEl;
        }
      }

      let artCtl = null;
      if (art) {
        entry.art = art;
        artCtl = this.renderArtCard(entry, anchor, false);
        anchor = artCtl.el;
        this.retireStaleArtOffers(artCtl);
      }

      if (linkChips.length) {
        entry.ln = linkChips;
        this.renderLinks(linkChips, anchor);
      }

      if (suggests.length) {
        entry.sg = suggests;
        this.renderSuggests(suggests, anchor);
      }
      if (followup) {

        entry.f = 1;
        const question = this.lastUserQuestion();
        if (question) entry.q = question;
        this.renderFollowupCard(entry, anchor);
      }
      this.transcript.push(entry);
      this.saveTranscript();

      if (artCtl) {
        if (autostart && art.state === 'offer' && !art.ambiguous && !this.artBusyElsewhere(artCtl)) {
          this.startArtPaint(artCtl);
        } else if (art.state === 'offer' || art.state === 'out_of_range') {
          this.announceArt(this.artOfferAnnouncement(art));
        }
      }

      if (!this._previewOpen) this.startRevealTour();

      if (this._previewOpen && this.previewEls) {
        this.previewEls.live.textContent = this.strings.previewReplyReady || '';
      }
    }

    lastUserQuestion() {
      for (let i = this.transcript.length - 1; i >= 0; i--) {
        if (this.transcript[i].r === 'u') return clean(this.transcript[i].c, MAX_CONTENT);
      }
      return '';
    }

    renderFollowupCard(entry, afterEl) {
      this._followupSeq += 1;
      const emailId = 'SalesCuratorFollowupEmail' + this._followupSeq;
      const noteId = 'SalesCuratorFollowupNote' + this._followupSeq;

      const card = document.createElement('form');
      card.className = 'curator__followup';
      card.dataset.curatorFollowup = '';
      card.noValidate = true;

      const promptText = this.strings.followupPrompt || '';
      if (promptText && entry.c !== promptText) {
        const prompt = document.createElement('p');
        prompt.className = 'curator__followup-prompt';
        prompt.textContent = promptText;
        card.appendChild(prompt);
      }

      const emailLabel = document.createElement('label');
      emailLabel.className = 'visually-hidden';
      emailLabel.htmlFor = emailId;
      emailLabel.textContent = this.strings.followupEmailLabel || '';
      const email = document.createElement('input');
      email.type = 'email';
      email.id = emailId;
      email.className = 'curator__followup-input';
      email.autocomplete = 'email';
      email.required = true;
      email.maxLength = MAX_EMAIL;
      email.placeholder = this.strings.followupEmailPlaceholder || '';
      card.append(emailLabel, email);

      const noteLabel = document.createElement('label');
      noteLabel.className = 'visually-hidden';
      noteLabel.htmlFor = noteId;
      noteLabel.textContent = this.strings.followupNoteLabel || '';
      const note = document.createElement('input');
      note.type = 'text';
      note.id = noteId;
      note.className = 'curator__followup-input curator__followup-note';
      note.autocomplete = 'off';
      note.maxLength = MAX_NOTE;
      note.placeholder = this.strings.followupNotePlaceholder || '';
      card.append(noteLabel, note);

      const status = document.createElement('p');
      status.className = 'curator__followup-status';
      status.setAttribute('role', 'status');
      status.hidden = true;

      const send = document.createElement('button');
      send.type = 'submit';
      send.className = 'curator__followup-send';
      send.textContent = this.strings.followupSend || '';
      card.append(send, status);

      card.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submitFollowup(entry, card, email, note, send, status);
      });

      let anchor = afterEl;
      if (anchor && anchor.nextElementSibling && anchor.nextElementSibling.classList.contains('curator__cards')) {
        anchor = anchor.nextElementSibling;
      }
      if (anchor && anchor.parentNode === this.messagesEl) anchor.after(card);
      else this.messagesEl.appendChild(card);
      this.scrollToEnd(true);
      return card;
    }

    async submitFollowup(entry, card, email, note, send, status) {
      const value = clean(email.value, MAX_EMAIL);
      if (!EMAIL_RE.test(value)) {
        status.hidden = false;
        status.textContent = this.strings.followupEmailInvalid || '';
        email.focus();
        return;
      }
      send.disabled = true;
      card.classList.add('is-busy');
      status.hidden = true;
      try {
        await fetchJSON(this.api('/api/chat/followup'), FETCH_TIMEOUT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'omit',
          body: JSON.stringify({
            email: value,
            question: clean(entry.q, MAX_CONTENT),
            note: clean(note.value, MAX_NOTE),
          }),
        });

        entry.f = 2;
        delete entry.q;
        const confirmation = clean(this.strings.followupConfirmed, MAX_CONTENT);
        if (confirmation) {
          this.transcript.push({ r: 'a', c: confirmation });
          this.renderBubble('bot', confirmation);
        }
        this.saveTranscript();

        if (this.input && !this.input.disabled) this.input.focus({ preventScroll: true });
        card.remove();
      } catch (err) {
        status.hidden = false;
        if (err && err.status === 400) {

          status.textContent = this.strings.followupEmailInvalid || '';
          email.focus();
        } else {

          status.textContent = this.strings.followupRetry || '';
        }
        send.disabled = false;
        card.classList.remove('is-busy');
      }
    }

    validPaint(raw) {
      if (!raw || typeof raw !== 'object' || Array.isArray(raw) || raw.v !== 1) return null;
      const status = raw.status === 'offer' || raw.status === 'out_of_range' ? raw.status : '';
      if (!status) return null;
      const constraint = raw.constraint === 'max' ? 'max' : 'exact';
      if (status === 'out_of_range') {
        const w = artNumber(raw.w, 0.1, 100000);
        const h = artNumber(raw.h, 0.1, 100000);
        if (w == null || h == null) return null;
        const out = {
          v: 1,
          w: artRound(w),
          h: artRound(h),
          orient: artOrient(w, h),
          ambiguous: false,
          constraint,
          status,
          state: 'out_of_range',
          limits: artLimits(raw.limits),
        };
        if (raw.reason === 'too_large' || raw.reason === 'too_small') out.reason = raw.reason;
        out.autostart = false;
        return out;
      }
      const main = artSide(raw);
      if (!main) return null;
      const art = {
        v: 1,
        w: main.w,
        h: main.h,
        orient: main.orient,
        ambiguous: raw.ambiguous === true,
        constraint,
        status,
        price: main.price,
        offer: main.offer,
        state: 'offer',
      };

      if (art.ambiguous && art.w !== art.h) {
        const flip = artSide(raw.flip);
        if (flip && !(flip.w === art.w && flip.h === art.h)) art.flip = flip;
      }
      art.autostart = raw.autostart === true && !art.ambiguous;
      return art;
    }

    sanitizeStoredArt(raw) {
      if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
      const base = this.validPaint(Object.assign({}, raw, { autostart: false }));
      if (!base) return null;
      delete base.autostart;
      const sup = raw.sup === true;
      if (base.status === 'out_of_range') {
        if (sup) base.sup = true;
        return base;
      }
      const state = ART_STATES.indexOf(raw.state) > -1 && raw.state !== 'out_of_range' ? raw.state : 'offer';
      base.state = state;
      const art = raw.art ? artResult(raw.art, this.serviceUrl) : null;
      if (art) base.art = art;
      if (state === 'painting') {
        const job = this.artJob(raw.job);
        if (job) base.job = job;
        else base.state = art ? 'done' : 'offer';
      }
      if (typeof raw.err === 'string' && ART_ERRORS[raw.err] && (base.state === 'error' || base.state === 'done')) {
        base.err = raw.err;
      }
      if (base.state === 'done' && !art) {
        base.state = 'error';
        base.err = 'expired';
      }
      if (base.state === 'error' && !base.err) base.err = 'generic';

      if ((base.state === 'error' || base.state === 'done') && raw.lostJob) {
        const lost = this.artJob(raw.lostJob);
        if (lost) base.lostJob = lost;
      }
      if (sup && (base.state === 'offer' || base.state === 'error')) base.sup = true;
      return base;
    }

    artJob(raw) {
      if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
      const id = typeof raw.id === 'string' && ART_UUID_RE.test(raw.id) ? raw.id.toLowerCase() : '';
      const now = Date.now();
      const started = artNumber(raw.started, now - 7 * 86400000, now + 300000);
      if (!id || started == null) return null;
      const pos = artNumber(raw.pos, 0, 9999);
      const job = {
        id,
        started,
        stage: ART_STAGES.indexOf(raw.stage) > -1 ? raw.stage : 'queued',
        pos: pos == null ? 0 : Math.floor(pos),
      };

      const ran = artNumber(raw.ran, started, now + 300000);
      if (ran != null) job.ran = ran;
      return job;
    }

    renderArtCard(entry, afterEl, restoring) {
      const root = document.createElement('div');
      root.className = 'curator__art';
      root.dataset.curatorArt = '';
      root.setAttribute('role', 'group');

      root.setAttribute('aria-live', 'off');
      root.tabIndex = -1;
      const ctl = {
        entry,
        el: root,
        pollTimer: 0,
        tickTimer: 0,
        fails: 0,
        polledOnce: false,
        sending: false,
        sendingAt: 0,
        imgFailed: false,
        focusAction: '',
        dead: false,
        progressEl: null,
        elapsedEl: null,
      };
      this._artCtls.add(ctl);
      this.paintArtCard(ctl);
      if (afterEl && afterEl.parentNode === this.messagesEl) afterEl.after(root);
      else this.messagesEl.appendChild(root);
      if (restoring && entry.art.state === 'painting' && entry.art.job) this.resumeArtJob(ctl);
      this.scrollToEnd();
      return ctl;
    }

    artSizeText(w, h) {
      return interp(this.strings.artSize || '[w]″ × [h]″', { w: artFmt(w), h: artFmt(h) });
    }

    artSpokenSize(w, h) {
      return interp(this.strings.artSizeSpoken || '[w] by [h] inches', { w: artFmt(w), h: artFmt(h) });
    }

    artKey(a) {
      return artFmt(a.w) + 'x' + artFmt(a.h);
    }

    artKeys(a) {
      const keys = [this.artKey(a)];
      if (a.flip) keys.push(this.artKey(a.flip));
      if (a.ambiguous) keys.push(artFmt(a.h) + 'x' + artFmt(a.w));
      return keys;
    }

    artRetirable(a) {
      return !!a && !a.sup && !a.job &&
        (a.state === 'offer' || a.state === 'error' || a.state === 'out_of_range');
    }

    supersedeArtEntries(entries) {
      const seen = new Set();
      for (let i = entries.length - 1; i >= 0; i--) {
        const a = entries[i] && entries[i].r === 'a' ? entries[i].art : null;
        if (!a || a.sup) continue;
        const keys = this.artKeys(a);
        if (this.artRetirable(a) && keys.some((k) => seen.has(k))) {
          a.sup = true;
          continue;
        }
        for (const k of keys) seen.add(k);
      }
    }

    retireStaleArtOffers(fresh) {
      const keys = new Set(this.artKeys(fresh.entry.art));
      for (const ctl of this._artCtls) {
        if (ctl === fresh || ctl.dead || ctl.headless || ctl.sending) continue;
        const a = ctl.entry.art;
        if (!this.artRetirable(a) || !this.artKeys(a).some((k) => keys.has(k))) continue;
        a.sup = true;
        this.stopArtJob(ctl);
        if (ctl.el && ctl.el.contains(document.activeElement)) {
          const target = fresh.el.querySelector('[data-art-focus]') || fresh.el;
          target.focus({ preventScroll: true });
        }
        ctl.focusAction = '';
        if (ctl.el) this.paintArtCard(ctl);
      }
    }

    resumeArtJobsHeadless() {
      if (!this._artCtls || !Array.isArray(this.transcript)) return;
      let touched = false;
      for (const entry of this.transcript) {
        if (!entry || entry.r !== 'a' || !entry.art || entry.art.state !== 'painting') continue;
        const art = this.sanitizeStoredArt(entry.art);
        touched = true;
        if (!art) {
          delete entry.art;
          continue;
        }
        entry.art = art;
        if (art.state !== 'painting' || !art.job) continue;
        const ctl = {
          entry,
          el: null,
          headless: true,
          pollTimer: 0,
          tickTimer: 0,
          fails: 0,
          polledOnce: false,
          sending: false,
          sendingAt: 0,
          imgFailed: false,
          focusAction: '',
          dead: false,
          progressEl: null,
          elapsedEl: null,
        };
        this._artCtls.add(ctl);
        this.scheduleArtPoll(ctl, 1500);
      }
      if (touched) this.saveTranscript();
    }

    stopHeadlessArt() {
      if (!this._artCtls) return;
      for (const ctl of Array.from(this._artCtls)) {
        if (!ctl.headless) continue;
        ctl.dead = true;
        this.stopArtJob(ctl);
        this._artCtls.delete(ctl);
      }
    }

    artErrorText(kind) {
      const def = ART_ERRORS[kind] || ART_ERRORS.generic;
      return this.strings[def.key] || this.strings.artErrorGeneric || '';
    }

    appendTemplate(el, template, vars) {
      for (const part of String(template || '').split(/(\[\w+\])/)) {
        if (!part) continue;
        const key = part.charAt(0) === '[' ? part.slice(1, -1) : '';
        if (key && Object.prototype.hasOwnProperty.call(vars, key)) {
          const value = vars[key];
          el.appendChild(value instanceof Node ? value : document.createTextNode(String(value)));
        } else {
          el.appendChild(document.createTextNode(part));
        }
      }
    }

    artDepthLabel(depth, short) {
      const S = this.strings;
      if (depth === '3/4 Inch') return (short ? S.artDepthSlimShort : S.artDepthSlim) || '';
      return (short ? S.artDepthGalleryShort : S.artDepthGallery) || '';
    }

    buildArtPrice(price) {
      if (!price) return null;
      const line = document.createElement('p');
      line.className = 'curator__art-price';
      const main = document.createElement('span');
      main.className = 'curator__art-price-main';
      const strong = document.createElement('strong');
      strong.textContent = artMoney(price.amounts[price.defaultDepth]);
      this.appendTemplate(main, this.strings.artPrice || '[price] · [depth]', {
        price: strong,
        depth: this.artDepthLabel(price.defaultDepth, false),
      });
      line.appendChild(main);
      for (const depth of ART_DEPTHS) {
        if (depth === price.defaultDepth || price.amounts[depth] == null) continue;
        const alt = document.createElement('span');
        alt.className = 'curator__art-price-alt';
        alt.textContent = interp(this.strings.artPriceAlt || '[depth] [price]', {
          depth: this.artDepthLabel(depth, true),
          price: artMoney(price.amounts[depth]),
        });
        line.appendChild(alt);
      }
      return line;
    }

    artButton(className, label, ariaLabel, action, onClick) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = className;
      button.dataset.artAction = action;
      button.textContent = label;
      if (ariaLabel) button.setAttribute('aria-label', ariaLabel);
      button.addEventListener('click', onClick);
      return button;
    }

    artNote(text, isError) {
      const note = document.createElement('p');
      note.className = 'curator__art-note' + (isError ? ' curator__art-note--error' : '');
      note.textContent = text;
      return note;
    }

    buildArtStage(ctl, view) {
      const a = ctl.entry.art;
      const showArt = view === 'done' && a.art && !ctl.imgFailed && !artExpired(a.art);
      const w = showArt ? a.art.w : a.w;
      const h = showArt ? a.art.h : a.h;
      const stage = document.createElement('div');
      stage.className = 'curator__art-stage';
      const canvas = document.createElement('div');
      canvas.className = 'curator__art-canvas';
      canvas.style.setProperty('--art-w', String(w));
      canvas.style.setProperty('--art-h', String(h));
      canvas.style.setProperty('--art-r', String(Math.round((w / h) * 10000) / 10000));
      const depth = (a.price && a.price.defaultDepth) || artDefaultDepth(w, h);
      canvas.dataset.depth = depth === '3/4 Inch' ? 'slim' : 'gallery';

      if (w / h < 1 / 3) canvas.dataset.slim = 'tall';
      else if (h / w < 1 / 3) canvas.dataset.slim = 'wide';
      if (showArt) {
        const src = this.api(a.art.preview);
        let sameHost = false;
        try { sameHost = new URL(src).hostname === new URL(this.serviceUrl).hostname; } catch (err) { sameHost = false; }
        if (sameHost) {
          const img = document.createElement('img');
          img.className = 'curator__art-img';
          img.alt = interp(this.strings.artPreviewAlt || '', { size: this.artSpokenSize(w, h) });
          img.decoding = 'async';
          if (a.art.width && a.art.height) {
            img.width = a.art.width;
            img.height = a.art.height;
          }

          img.addEventListener('error', () => {
            if (ctl.dead || ctl.imgFailed || ctl.entry.art.art !== a.art) return;
            ctl.imgFailed = true;
            this.paintArtCard(ctl);
          });
          img.src = src;
          canvas.appendChild(img);
        } else {
          ctl.imgFailed = true;
        }
      } else if (view === 'painting') {
        canvas.classList.add('is-painting');
        for (const layer of ['a', 'b', 'sweep']) {
          const wash = document.createElement('span');
          wash.className = 'curator__art-wash curator__art-wash--' + layer;
          wash.setAttribute('aria-hidden', 'true');
          canvas.appendChild(wash);
        }
      }
      if (!canvas.firstChild) {
        const dims = document.createElement('span');
        dims.className = 'curator__art-dims';
        dims.setAttribute('aria-hidden', 'true');
        dims.textContent = this.artSizeText(w, h);
        canvas.appendChild(dims);
      }
      stage.appendChild(canvas);
      return stage;
    }

    paintArtCard(ctl) {
      const root = ctl.el;
      const a = ctl.entry.art;
      const S = this.strings;
      const hadFocus = root.contains(document.activeElement);
      const view = ctl.sending ? 'painting' : a.state;
      const size = this.artSizeText(a.w, a.h);
      const spoken = this.artSpokenSize(a.w, a.h);
      this.stopArtTicker(ctl);
      ctl.progressEl = null;
      ctl.elapsedEl = null;
      root.dataset.state = view;
      root.dataset.orient = a.orient;
      root.setAttribute('aria-label', interp(S.artLabel || '', { size: spoken }));
      root.textContent = '';

      const grid = document.createElement('div');
      grid.className = 'curator__art-grid';
      root.appendChild(grid);

      if (a.sup) {
        root.dataset.state = 'superseded';
        const body = document.createElement('div');
        body.className = 'curator__art-body';
        body.appendChild(this.artNote(interp(S.artSuperseded || '', { size }), false));
        grid.appendChild(body);
        ctl.focusAction = '';
        if (hadFocus) root.focus({ preventScroll: true });
        return;
      }

      if (view === 'out_of_range') {
        const body = document.createElement('div');
        body.className = 'curator__art-body';
        body.appendChild(this.artNote(this.artOutOfRangeText(a), false));
        grid.appendChild(body);
        return;
      }

      grid.appendChild(this.buildArtStage(ctl, view));
      const body = document.createElement('div');
      body.className = 'curator__art-body';
      grid.appendChild(body);

      const title = document.createElement('p');
      title.className = 'curator__art-title';
      title.textContent = interp((view === 'done' ? S.artTitleDone : S.artTitle) || '', { size });
      body.appendChild(title);

      const price = this.buildArtPrice(a.price);
      const actions = document.createElement('div');
      actions.className = 'curator__art-actions';

      if (view === 'offer') {
        if (S.artOfferNote) body.appendChild(this.artNote(S.artOfferNote, false));
        if (price) body.appendChild(price);
        const paint = this.artButton(
          'curator__art-primary', S.artPaint || '', interp(S.artPaintLabel || '', { size: spoken }), 'paint',
          () => this.startArtPaint(ctl)
        );
        paint.dataset.artFocus = '';
        actions.appendChild(paint);
        if (a.flip) {
          const flipLabel = interp(S.artFlip || '', { w: artFmt(a.flip.w), h: artFmt(a.flip.h) });
          const flip = this.artButton(
            'curator__art-flip', flipLabel,
            interp(S.artFlipLabel || '', { w: artFmt(a.flip.w), h: artFmt(a.flip.h) }), 'flip',
            () => this.flipArt(ctl)
          );
          actions.appendChild(flip);
        }
      } else if (view === 'painting') {
        if (price) body.appendChild(price);
        const progress = document.createElement('p');
        progress.className = 'curator__art-progress';
        progress.setAttribute('aria-live', 'off');
        const stageText = document.createElement('span');
        stageText.className = 'curator__art-stage-text';
        const elapsed = document.createElement('span');
        elapsed.className = 'curator__art-elapsed';
        progress.append(stageText, elapsed);
        body.appendChild(progress);
        if (S.artPaintingHint) body.appendChild(this.artNote(S.artPaintingHint, false));
        ctl.progressEl = stageText;
        ctl.elapsedEl = elapsed;
        this.updateArtProgress(ctl);
        this.startArtTicker(ctl);
      } else if (view === 'done') {
        if (price) body.appendChild(price);

        const gone = artExpired(a.art);
        const unloaded = !gone && ctl.imgFailed;
        if (gone) body.appendChild(this.artNote(S.artExpired || '', true));
        else if (unloaded) body.appendChild(this.artNote(S.artPreviewFailed || '', true));
        else if (a.err) body.appendChild(this.artNote(this.artErrorText(a.err), true));
        else if (S.artWatermarkNote) body.appendChild(this.artNote(S.artWatermarkNote, false));
        if (!gone && !this.artOrderable && S.artOrderUnavailable) {
          body.appendChild(this.artNote(S.artOrderUnavailable, false));
        }
        if (!gone && this.artOrderable) {
          const order = this.artButton(
            'curator__art-primary', S.artOrder || '', interp(S.artOrderLabel || '', { size: spoken }), 'order',
            () => this.orderArt(ctl)
          );
          order.dataset.artFocus = '';
          actions.appendChild(order);
        }
        if (unloaded) {
          actions.appendChild(this.artButton(
            'curator__art-secondary', S.artReload || '', interp(S.artReloadLabel || '', { size: spoken }), 'reload',
            () => {
              if (ctl.dead) return;
              ctl.imgFailed = false;
              this.paintArtCard(ctl);
            }
          ));
        }
        const again = this.artButton(
          gone ? 'curator__art-primary' : 'curator__art-secondary',
          S.artAgain || '', interp(S.artAgainLabel || '', { size: spoken }), 'again',
          () => this.startArtPaint(ctl)
        );
        if (gone || !this.artOrderable) again.dataset.artFocus = '';
        actions.appendChild(again);
      } else {

        if (price) body.appendChild(price);
        const kind = ART_ERRORS[a.err] ? a.err : 'generic';
        body.appendChild(this.artNote(this.artErrorText(kind), true));
        if (ART_ERRORS[kind].retry) {
          const retry = this.artButton(
            'curator__art-primary', S.artRetry || '', interp(S.artRetryLabel || '', { size: spoken }), 'retry',
            () => this.startArtPaint(ctl)
          );
          retry.dataset.artFocus = '';
          actions.appendChild(retry);
        }
      }
      if (actions.childElementCount) body.appendChild(actions);

      if (hadFocus) {
        const wanted = ctl.focusAction ? root.querySelector('[data-art-action="' + ctl.focusAction + '"]') : null;
        const target = wanted || root.querySelector('[data-art-focus]') || root;
        target.focus({ preventScroll: true });
      }
      ctl.focusAction = '';
    }

    artStageText(ctl) {
      const S = this.strings;
      const job = ctl.entry.art.job;
      if (ctl.sending || !job) return S.artStageSending || '';
      if (job.stage === 'queued') {
        return job.pos > 0 ? interp(S.artStageQueue || '', { n: String(job.pos) }) : S.artStageQueued || '';
      }
      if (job.stage === 'checking') return S.artStageChecking || '';
      if (job.stage === 'finishing') return S.artStageFinishing || '';
      return S.artStagePainting || '';
    }

    updateArtProgress(ctl) {
      if (ctl.progressEl) ctl.progressEl.textContent = this.artStageText(ctl);
      this.updateArtElapsed(ctl);
    }

    updateArtElapsed(ctl) {
      if (!ctl.elapsedEl) return;
      const job = ctl.entry.art.job;
      const started = !ctl.sending && job ? job.started : ctl.sendingAt;
      ctl.elapsedEl.textContent = started
        ? interp(this.strings.artElapsed || '[time]', { time: artElapsed(Date.now() - started) })
        : '';
    }

    startArtTicker(ctl) {
      this.stopArtTicker(ctl);
      if (ctl.dead || !ctl.elapsedEl) return;
      ctl.tickTimer = window.setInterval(() => {
        if (ctl.dead || !ctl.elapsedEl || !ctl.el.isConnected) {
          this.stopArtTicker(ctl);
          return;
        }
        this.updateArtElapsed(ctl);
      }, 1000);
    }

    stopArtTicker(ctl) {
      if (ctl.tickTimer) window.clearInterval(ctl.tickTimer);
      ctl.tickTimer = 0;
    }

    stopArtJob(ctl) {
      if (ctl.pollTimer) window.clearTimeout(ctl.pollTimer);
      ctl.pollTimer = 0;
      this.stopArtTicker(ctl);
    }

    clearArtJobs() {
      if (!this._artCtls) return;
      for (const ctl of this._artCtls) {
        ctl.dead = true;
        this.stopArtJob(ctl);
      }
      this._artCtls.clear();
      if (this._artLiveTimer) window.clearTimeout(this._artLiveTimer);
      this._artLiveTimer = null;
      if (this.artLiveEl) this.artLiveEl.textContent = '';
    }

    artBusyElsewhere(self) {
      for (const ctl of this._artCtls) {
        if (ctl === self || ctl.dead) continue;
        if (ctl.sending || ctl.entry.art.state === 'painting') return true;
      }
      return false;
    }

    announceArt(text) {
      const el = this.artLiveEl || this.avatarLiveEl;
      const value = clean(text, 300);
      if (!el || !value) return;
      if (this._artLiveTimer) window.clearTimeout(this._artLiveTimer);
      el.textContent = '';
      this._artLiveTimer = window.setTimeout(() => {
        el.textContent = value;
        this._artLiveTimer = null;
      }, 60);
    }

    artOutOfRangeText(a) {
      const lim = a.limits || ART_LIMITS;
      const vars = {
        size: this.artSizeText(a.w, a.h),
        min_short: artFmt(lim.minShort),
        min_long: artFmt(lim.minLong),
        max_short: artFmt(lim.maxShort),
        max_long: artFmt(lim.maxLong),
      };
      const key = a.reason === 'too_large' ? 'artTooLarge' : a.reason === 'too_small' ? 'artTooSmall' : 'artOutOfRange';
      return interp(this.strings[key] || '', vars);
    }

    artOfferAnnouncement(a) {
      const S = this.strings;
      if (a.state === 'out_of_range') return this.artOutOfRangeText(a);
      let text = interp(S.artTitle || '', { size: this.artSpokenSize(a.w, a.h) });
      if (a.price) text += ' — ' + artMoney(a.price.amounts[a.price.defaultDepth]);
      return text;
    }

    async startArtPaint(ctl) {
      if (ctl.sending || ctl.dead) return;
      const a = ctl.entry.art;
      if (a.status !== 'offer' || a.state === 'painting' || a.sup) return;

      const lost = this.artJob(a.lostJob);
      delete a.lostJob;
      if (lost) {
        a.state = 'painting';
        a.job = { id: lost.id, started: Date.now(), stage: 'queued', pos: 0 };
        delete a.err;
        ctl.fails = 0;
        ctl.polledOnce = false;
        ctl.imgFailed = false;
        this.saveTranscript();
        this.paintArtCard(ctl);
        this.scheduleArtPoll(ctl, 250);
        return;
      }
      if (!a.offer) {
        this.failArt(ctl, 'offer_expired', 'no_offer');
        return;
      }
      const gen = this.generation;
      ctl.sending = true;
      ctl.sendingAt = Date.now();
      ctl.imgFailed = false;
      this.paintArtCard(ctl);
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), ART_PAINT_TIMEOUT);
      let status = 0;
      let data = null;
      try {
        const res = await fetch(this.api('/api/curator/paint'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'omit',
          signal: controller.signal,
          body: JSON.stringify({ offer: a.offer }),
        });
        status = res.status;
        try { data = await res.json(); } catch (jsonErr) { data = null; }
      } catch (err) {
        status = 0;
      } finally {
        window.clearTimeout(timer);
      }
      ctl.sending = false;
      if (ctl.dead || gen !== this.generation) return;

      const jobId = data && typeof data.job_id === 'string' && ART_UUID_RE.test(data.job_id)
        ? data.job_id.toLowerCase()
        : '';
      if (status >= 200 && status < 300 && jobId) {
        const pos = artNumber(data.queue_position, 0, 9999);
        a.state = 'painting';
        a.job = {
          id: jobId,
          started: Date.now(),
          stage: ART_STAGES.indexOf(data.stage) > -1 ? data.stage : 'queued',
          pos: pos == null ? 0 : Math.floor(pos),
        };
        delete a.err;
        ctl.fails = 0;
        ctl.polledOnce = false;
        this.saveTranscript();
        this.paintArtCard(ctl);
        this.announceArt(interp(this.strings.artAnnounceStart || '', { size: this.artSpokenSize(a.w, a.h) }));
        this.fireEvent('paint_start', this.artKey(a));
        this.scheduleArtPoll(ctl, ART_POLL_MS);
        this.scrollToEnd();
        return;
      }
      const code = data && typeof data.error === 'string' ? clean(data.error, 40) : '';
      let kind = 'generic';
      if (status === 400) kind = 'offer_expired';
      else if (status === 403) kind = 'paint_unavailable';
      else if (status === 409) kind = 'paint_in_progress';
      else if (status === 402) kind = 'quota_exceeded';
      else if (status === 429) kind = code === 'paint_limit' ? 'paint_limit' : 'generic';
      else if (status === 503) kind = code === 'busy' ? 'busy' : 'paint_unavailable';
      this.failArt(ctl, kind, code || (status ? 'http_' + status : 'network'));
    }

    resumeArtJob(ctl) {
      this.startArtTicker(ctl);
      this.scheduleArtPoll(ctl, 250);
    }

    scheduleArtPoll(ctl, delay) {
      if (ctl.dead) return;
      if (ctl.pollTimer) window.clearTimeout(ctl.pollTimer);
      ctl.pollTimer = window.setTimeout(() => {
        ctl.pollTimer = 0;
        this.pollArtJob(ctl);
      }, delay);
    }

    async pollArtJob(ctl) {
      const a = ctl.entry.art;
      const job = a.job;
      if (ctl.dead || a.state !== 'painting' || !job) return;
      const limit = job.ran ? ART_POLL_DEADLINE_MS : ART_QUEUE_DEADLINE_MS;
      if (ctl.polledOnce && Date.now() - (job.ran || job.started) > limit) {
        this.failArt(ctl, 'generic', 'generation_timeout', true);
        return;
      }
      const gen = this.generation;
      let data = null;
      let status = 0;
      try {
        data = await fetchJSON(this.api('/api/portrait/job/' + encodeURIComponent(job.id)), FETCH_TIMEOUT, {
          credentials: 'omit',
          cache: 'no-store',
        });
      } catch (err) {
        status = (err && err.status) || 0;
        data = null;
      }
      ctl.polledOnce = true;
      if (ctl.dead || gen !== this.generation || a.job !== job || a.state !== 'painting') return;
      if (!data || typeof data !== 'object') {
        if (status === 404) {
          this.failArt(ctl, a.art ? 'generic' : 'job_lost', 'job_not_found');
          return;
        }
        ctl.fails += 1;
        if (ctl.fails >= ART_MAX_POLL_FAILS) {
          this.failArt(ctl, 'generic', 'poll_failed', true);
          return;
        }
        this.scheduleArtPoll(ctl, ART_POLL_MS);
        return;
      }
      ctl.fails = 0;
      if (data.status === 'done') {
        const art = artResult(data.art, this.serviceUrl);
        if (art) this.finishArt(ctl, art);
        else this.failArt(ctl, 'generic', 'missing_art');
        return;
      }
      if (data.status === 'error') {
        const code = typeof data.error === 'string' ? clean(data.error, 40) : '';
        this.failArt(ctl, this.artJobErrorKind(code), code || 'job_error');
        return;
      }
      if (data.status === 'queued' || data.status === 'running') {
        const stage = ART_STAGES.indexOf(data.stage) > -1
          ? data.stage
          : data.status === 'queued' ? 'queued' : 'painting';
        const rawPos = data.status === 'queued' ? artNumber(data.queue_position, 0, 9999) : 0;
        const pos = rawPos == null ? 0 : Math.floor(rawPos);
        const ranNow = !job.ran && (data.status === 'running' || stage !== 'queued');
        if (ranNow) job.ran = Date.now();
        if (stage !== job.stage || pos !== job.pos || ranNow) {
          job.stage = stage;
          job.pos = pos;
          this.saveTranscript();
          this.updateArtProgress(ctl);
        }
      }
      this.scheduleArtPoll(ctl, ART_POLL_MS);
    }

    artJobErrorKind(code) {
      if (code === 'prompt_rejected' || code === 'content_rejected') return 'rejected';
      if (code === 'imagegen_offline' || code === 'paint_unavailable') return 'paint_unavailable';
      if (code === 'imagegen_busy' || code === 'busy') return 'busy';
      return 'generic';
    }

    finishArt(ctl, art) {
      const a = ctl.entry.art;
      this.stopArtJob(ctl);
      a.art = art;
      a.state = 'done';
      delete a.job;
      delete a.err;
      delete a.lostJob;
      ctl.imgFailed = false;
      this.saveTranscript();
      this.fireEvent('paint_done', this.artKey(a));
      if (ctl.headless) return;
      this.paintArtCard(ctl);
      this.announceArt(interp(this.strings.artAnnounceDone || '', { size: this.artSpokenSize(art.w, art.h) }));
      this.scrollToEnd();
    }

    failArt(ctl, kind, detail, keepJob) {
      if (ctl.dead) return;
      const a = ctl.entry.art;
      this.stopArtJob(ctl);
      ctl.sending = false;

      if (keepJob && a.job) a.lostJob = { id: a.job.id, started: a.job.started };
      else delete a.lostJob;
      delete a.job;
      a.err = ART_ERRORS[kind] ? kind : 'generic';
      a.state = a.art && !artExpired(a.art) ? 'done' : 'error';
      this.saveTranscript();
      this.fireEvent('paint_error', detail || kind);
      if (ctl.headless) return;
      this.paintArtCard(ctl);
      this.announceArt(this.artErrorText(a.err));
      this.scrollToEnd();
    }

    flipArt(ctl) {
      const a = ctl.entry.art;
      if (ctl.dead || a.state !== 'offer' || !a.flip || ctl.sending) return;
      const next = a.flip;
      a.flip = { w: a.w, h: a.h, orient: a.orient, price: a.price, offer: a.offer };
      a.w = next.w;
      a.h = next.h;
      a.orient = next.orient;
      a.price = next.price;
      a.offer = next.offer;
      this.saveTranscript();
      ctl.focusAction = 'flip';
      this.paintArtCard(ctl);
      this.fireEvent('paint_flip', this.artKey(a));
    }

    orderArt(ctl) {
      const a = ctl.entry.art;
      const art = a.art;
      const m = art ? /\/print\?exp=(\d{1,12})&sig=([0-9a-f]{16,256})$/.exec(art.print) : null;
      if (!this.artOrderable || !art || !m || artExpired(art)) {
        this.paintArtCard(ctl);
        return;
      }
      const depth = (a.price && a.price.defaultDepth) || artDefaultDepth(art.w, art.h);
      const url = '/pages/ai-art-studio?cur=' + encodeURIComponent(art.id) +
        '&cexp=' + m[1] +
        '&csig=' + m[2] +
        '&w=' + artFmt(art.w) +
        '&h=' + artFmt(art.h) +
        '&d=' + (depth === '3/4 Inch' ? '0.75' : '1.5');
      this.fireEvent('paint_order', this.artKey(art));

      ssRemove(SS.panel);
      window.location.href = url;
    }

    lockComposer(kind) {
      this.locked = kind;
      const message = kind === 'banned'
        ? this.strings.errorBanned || ''
        : this.strings.errorDailyLimit || '';
      if (this.input) {
        this.input.value = '';
        this.input.disabled = true;
      }
      if (this.sendBtn) this.sendBtn.disabled = true;
      if (this.form) this.form.hidden = true;
      let notice = this.querySelector('[data-curator-lock-notice]');
      if (!notice && this.form && this.form.parentNode) {
        notice = document.createElement('p');
        notice.className = 'curator__lock-notice';
        notice.dataset.curatorLockNotice = '';
        notice.setAttribute('role', 'status');
        this.form.parentNode.appendChild(notice);
      }
      if (notice) {
        notice.textContent = message;

        notice.setAttribute('tabindex', '-1');
        notice.focus({ preventScroll: true });
      }
    }

    maybeShowRegisterNudge() {
      if (this.loggedIn || !this.registerUrl) return;
      const count = this.transcript.filter((m) => m.r === 'u').length;
      const key = count >= NUDGE_SECOND_AT
        ? SS.nudgeSecond
        : count >= NUDGE_FIRST_AT
          ? SS.nudgeFirst
          : '';
      if (!key || ssGet(key)) return;
      ssSet(key, '1');
      this.renderRegisterNudge();
    }

    renderRegisterNudge() {
      const wrap = document.createElement('div');
      wrap.className = 'curator__nudge';
      wrap.dataset.curatorNudge = '';

      const text = document.createElement('p');
      text.className = 'curator__nudge-text';
      text.textContent = this.strings.registerNudge || '';
      wrap.appendChild(text);

      const link = document.createElement('a');
      link.className = 'curator__nudge-link';
      link.href = this.registerUrl;
      link.textContent = this.strings.registerNudgeCta || '';
      wrap.appendChild(link);

      const dismiss = document.createElement('button');
      dismiss.type = 'button';
      dismiss.className = 'curator__nudge-dismiss';
      dismiss.setAttribute('aria-label', this.strings.registerNudgeDismiss || '');
      dismiss.textContent = '✕';
      dismiss.addEventListener('click', () => wrap.remove());
      wrap.appendChild(dismiss);

      this.messagesEl.appendChild(wrap);
      this.scrollToEnd(true);
    }

    recoverRecommendations(content, serverHandles, fallbackCards) {

      const known = (key) => this.productIndex.has(key) || (fallbackCards && fallbackCards.has(key));
      const handles = [];
      for (const handle of Array.isArray(serverHandles) ? serverHandles : []) {
        const key = clean(handle, 100).toLowerCase();
        if (known(key) && !handles.includes(key)) handles.push(key);
      }

      const text = String(content || '').replace(/\[\[(?:\s*recommend\s*:?\s*)?([^\]]+)\]\]/gi, (marker, inner) => {
        for (const part of inner.split(/[,;\n]/)) {
          if (handles.length >= MAX_CARDS) break;
          const key = clean(part, 100).toLowerCase().replace(/^[`'\"]+|[`'\"]+$/g, '');
          if (known(key) && !handles.includes(key)) handles.push(key);
        }
        return '';
      });

      return { text: text.replace(/\s+$/, ''), handles: handles.slice(0, MAX_CARDS) };
    }

    serverCardRecords(rows) {
      const map = new Map();
      if (!Array.isArray(rows)) return map;
      for (const row of rows.slice(0, 12)) {
        if (!row || typeof row !== 'object') continue;
        const h = clean(row.h, 100).toLowerCase();
        const t = clean(row.t, 120);
        const img = clean(row.img, 1000);
        const u = clean(row.u, 200);
        if (!h || !t || !img || !u || map.has(h)) continue;
        if (u.indexOf('/products/') !== 0) continue;
        let parsed = null;
        try { parsed = new URL(img); } catch (err) { continue; }
        if (parsed.protocol !== 'https:' || parsed.hostname !== 'cdn.shopify.com') continue;
        map.set(h, {
          h,
          t,
          p: clean(row.p, 80),
          img,
          min: 0,
          o: '',
          c: '',
        });
      }
      return map;
    }

    abortStream() {
      if (this._cancelPacing) this._cancelPacing();
      if (this.controller) this.controller.abort();
    }

    async buildContext() {
      const context = { page: clean(this.pageType + ':' + window.location.pathname, 200) };
      let products = [];

      if (this.activeCategory) {
        context.category = clean(this.activeCategory.title, 60);
        products = await this.productsFor(this.activeCategory.handle, this.activeCategory.title);
      }
      if (!products.length) {
        products = await this.productsFor('', '');
      }
      if (this.pageType === 'product') {
        const current = await this.currentProduct();
        if (current) products = [current].concat(products.filter((p) => p.h !== current.h));
      }

      const remembered = this.favorites.concat(this.recent);
      if (remembered.length) {
        const seen = new Set();
        products = remembered.concat(products).filter((product) => {
          if (!product || !product.h || seen.has(product.h)) return false;
          seen.add(product.h);
          return true;
        });
      }

      context.products = products.slice(0, MAX_PRODUCTS).map((p) => {
        const item = { h: p.h, t: p.t, p: p.p };
        if (p.o) item.o = p.o;
        if (p.c) item.c = p.c;
        return item;
      });

      const exclude = this.excludedHandles();
      if (exclude.length) context.exclude = exclude;
      return context;
    }

    excludedHandles() {
      const exclude = [];
      const seen = new Set();
      const add = (value) => {
        if (exclude.length >= MAX_EXCLUDE) return;
        const handle = clean(value, 100).toLowerCase();
        if (!handle || seen.has(handle)) return;
        seen.add(handle);
        exclude.push(handle);
      };
      for (let i = this.transcript.length - 1; i >= 0; i--) {
        const entry = this.transcript[i];
        if (entry.r !== 'a' || !Array.isArray(entry.k)) continue;
        for (const card of entry.k) {
          if (card && card.h) add(card.h);
        }
      }
      if (this.messagesEl) {
        for (const btn of this.messagesEl.querySelectorAll('.curator__card [data-curator-favorite]')) {
          add(btn.dataset.curatorFavorite);
        }
      }
      return exclude;
    }

    async productsFor(handle, collectionTitle) {
      const key = handle || '__all';
      if (this.poolCache.has(key)) return this.poolCache.get(key);

      const stored = ssGet(SS.category + key);
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          this.registerPool(key, parsed);
          return parsed;
        } catch (err) {  }
      }

      const url = handle
        ? '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + PRODUCTS_PER_CATEGORY
        : '/products.json?limit=' + PRODUCTS_PER_CATEGORY;
      try {
        const data = await fetchJSON(url, FETCH_TIMEOUT);
        const records = (data.products || []).map((item) => compactFromListing(item, collectionTitle));
        this.registerPool(key, records);
        ssSet(SS.category + key, JSON.stringify(records));
        return records;
      } catch (err) {
        this.poolCache.set(key, []);
        return [];
      }
    }

    registerPool(key, records) {
      this.poolCache.set(key, records);
      for (const record of records) this.productIndex.set(record.h, record);
    }

    currentProduct() {
      if (!this.currentProductPromise) {
        const path = window.location.pathname.replace(/\/$/, '');
        this.currentProductPromise = fetchJSON(path + '.js', FETCH_TIMEOUT)
          .then((product) => {
            const record = compactFromAjax(product);
            this.productIndex.set(record.h, record);
            return record;
          })
          .catch(() => null);
      }
      return this.currentProductPromise;
    }

    productSnapshot(record) {
      if (!record) return null;
      const snapshot = {
        h: clean(record.h, 80),
        t: clean(record.t, 120),
        p: clean(record.p, 80),
        img: clean(record.img, 1000),
        min: Math.max(0, Number(record.min) || 0),
        o: clean(record.o, 30),
        c: clean(record.c, 60),
      };
      const ri = cleanRoomImages(record.ri);
      if (ri) snapshot.ri = ri;
      return snapshot;
    }

    recordForCard(card) {
      return this.productIndex.get(card.h) || this.productSnapshot(card);
    }

    isFavorite(handle) {
      return this.favorites.some((item) => item.h === handle);
    }

    fireEvent(ev, val) {
      try {
        if (!this.serviceUrl) return;
        fetch(this.serviceUrl + '/api/chat/event', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ev: ev, val: String(val || '').slice(0, 140) }),
          credentials: 'omit'
        }).catch(() => {});
      } catch (e) {  }
    }

    toggleFavorite(record) {
      const item = this.productSnapshot(record);
      if (!item || !item.h) return;
      const index = this.favorites.findIndex((favorite) => favorite.h === item.h);
      if (index > -1) this.favorites.splice(index, 1);
      else { this.favorites.unshift(item); this.fireEvent('favorite', item.h); }
      this.favorites = this.favorites.slice(0, MAX_FAVORITES);
      lsSet(LS.favorites, JSON.stringify(this.favorites));
      this.renderSavedProducts();
      this.syncFavoriteButtons(item.h);
    }

    rememberRecent(record) {
      const item = this.productSnapshot(record);
      if (!item || !item.h) return;
      this.recent = [item].concat(this.recent.filter((recent) => recent.h !== item.h)).slice(0, MAX_RECENT);
      this.productIndex.set(item.h, item);
      lsSet(LS.recent, JSON.stringify(this.recent));
      this.renderRecent();
    }

    syncFavoriteButtons(handle) {
      const saved = this.isFavorite(handle);
      const title = (this.productIndex.get(handle) && this.productIndex.get(handle).t) || '';
      for (const button of this.querySelectorAll('[data-curator-favorite="' + CSS.escape(handle) + '"]')) {
        button.classList.toggle('is-active', saved);
        button.setAttribute('aria-pressed', String(saved));
        button.setAttribute(
          'aria-label',
          (saved ? this.strings.unfavorite || 'Remove from favorites' : this.strings.favorite || 'Save to favorites')
            + (title ? ' — ' + title : '')
        );
        button.textContent = saved ? '♥' : '♡';
      }
    }

    renderSavedProducts() {
      this.renderFavorites();
      this.renderRecent();
    }

    renderFavorites() {
      if (this.favoriteCountEl) this.favoriteCountEl.textContent = String(this.favorites.length);
      this.renderRailProducts(
        this.favoritesEl,
        this.favorites,
        this.strings.favoritesEmpty || 'Save artworks here while you browse.',
        true
      );
    }

    renderRecent() {
      this.renderRailProducts(
        this.recentEl,
        this.recent,
        this.strings.recentEmpty || 'Artworks you open will appear here.',
        false
      );
    }

    renderShortlist(cards) {
      if (!this.shortlistEl) return;
      const records = cards.map((card) => this.recordForCard(card)).filter(Boolean).slice(0, 3);
      this.renderRailProducts(
        this.shortlistEl,
        records,
        this.strings.shortlistEmpty || 'Your tailored picks will appear here.',
        false
      );
      const section = this.shortlistEl.closest('.curator__rail-card');
      if (section) section.hidden = !records.length;
    }

    renderRailProducts(container, records, emptyText, removable) {
      if (!container) return;
      container.textContent = '';
      if (!records.length) {
        const empty = document.createElement('p');
        empty.className = 'curator__rail-empty';
        empty.textContent = emptyText;
        container.appendChild(empty);
        return;
      }
      for (const record of records.slice(0, 5)) {
        const row = document.createElement('div');
        row.className = 'curator__rail-product';

        const link = document.createElement('a');
        link.className = 'curator__rail-product-link';
        link.href = '/products/' + encodeURIComponent(record.h);
        link.addEventListener('click', () => this.rememberRecent(record));
        if (record.img) {
          const image = document.createElement('img');
          image.src = sized(record.img, 120);
          image.alt = '';
          image.loading = 'lazy';
          image.width = 52;
          image.height = 52;
          link.appendChild(image);
        }
        const copy = document.createElement('span');
        copy.className = 'curator__rail-product-copy';
        const title = document.createElement('span');
        title.className = 'curator__rail-product-title';
        title.textContent = record.t;
        const price = document.createElement('span');
        price.className = 'curator__rail-product-price';
        price.textContent = record.p || (record.min ? interp(this.strings.priceFrom || '[price]', { price: money(record.min) }) : '');
        copy.append(title, price);
        link.appendChild(copy);
        row.appendChild(link);

        if (removable) {
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'curator__rail-product-remove';
          remove.setAttribute('aria-label', (this.strings.unfavorite || 'Remove from favorites') + ' — ' + record.t);
          remove.textContent = '×';
          remove.addEventListener('click', () => this.toggleFavorite(record));
          row.appendChild(remove);
        }
        container.appendChild(row);
      }
    }

    updateProTip() {
      if (!this.proTipEl) return;
      const room = this.activeCategory && this.activeCategory.title;
      this.proTipEl.textContent = room
        ? 'Try pairing ' + room + ' art with one color already present in your room for a collected, intentional look.'
        : this.strings.proTipDefault || 'Share your wall width and room colors for a more precise recommendation.';
    }

    setActiveRoom(value) {
      const room = normalizeRoom(value);
      if (room) this.activeRoom = room;
    }

    roomAwareImg(record) {
      if (!record) return '';
      if (this.activeRoom && record.ri && record.ri[this.activeRoom]) {
        return record.ri[this.activeRoom];
      }
      return record.img || '';
    }

    roomImageFromProduct(product) {
      if (!this.activeRoom || !product) return '';
      let rule = null;
      for (const candidate of ROOM_IMAGE_RULES) {
        if (candidate.key === this.activeRoom) {
          rule = candidate;
          break;
        }
      }
      if (!rule) return '';
      const candidates = [];
      if (Array.isArray(product.media)) {
        for (const media of product.media) {
          if (!media || (media.media_type && media.media_type !== 'image')) continue;
          const src = media.src || (media.preview_image && media.preview_image.src) || '';
          if (src) candidates.push({ src: String(src), alt: String(media.alt == null ? '' : media.alt) });
        }
      }
      if (!candidates.length && Array.isArray(product.images)) {
        for (const src of product.images) {
          if (src) candidates.push({ src: String(src), alt: '' });
        }
      }
      for (const candidate of candidates) {
        const file = candidate.src.split('?')[0].split('/').pop() || '';
        if (rule.re.test(file) || (candidate.alt && rule.re.test(candidate.alt))) return candidate.src;
      }
      return '';
    }

    renderBubble(kind, text) {
      const el = document.createElement('div');
      el.className = 'curator__msg curator__msg--' + (kind === 'user' ? 'user' : 'bot');
      if (kind === 'error') el.classList.add('curator__msg--error');
      this.setBubbleText(el, text);
      this.messagesEl.appendChild(el);
      this.scrollToEnd(true);
      return el;
    }

    renderErrorOnce(text, key) {
      const value = clean(text, MAX_CONTENT);
      if (!value) return null;
      const id = key || 'general';
      const now = Date.now();
      const previous = this._errorState[id];
      if (previous && previous.text === value && now - previous.at < 30000 && previous.el && previous.el.isConnected) {
        previous.at = now;

        this.messagesEl.appendChild(previous.el);
        this.scrollToEnd(true);
        return previous.el;
      }
      const el = this.renderBubble('error', value);
      this._errorState[id] = { text: value, at: now, el };
      return el;
    }

    setBubbleText(el, text) {

      const parts = [];
      for (const part of String(text == null ? '' : text).split(/\n{2,}/)) {
        const trimmed = part.trim();
        if (trimmed) parts.push(this.foldLines(trimmed));
      }

      for (let i = 0; i < el.children.length; i++) {
        if (el.children[i].tagName !== 'P') { el.textContent = ''; break; }
      }
      for (let i = 0; i < parts.length; i++) {
        let p = el.children[i];
        if (!p) {
          p = document.createElement('p');
          el.appendChild(p);
        } else if (p.dataset.src === parts[i]) {
          continue;
        }
        this.fillInline(p, parts[i]);
        p.dataset.src = parts[i];
      }
      while (el.children.length > parts.length) el.removeChild(el.lastElementChild);
      this.scrollToEnd();
    }

    foldLines(block) {
      const lines = String(block || '').split('\n');
      let out = '';
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (!line) continue;
        if (!out) { out = line; continue; }
        out += (/^(?:\d{1,2}[.)]|[-•–])\s/.test(line) ? '\n' : ' ') + line;
      }
      return out;
    }

    fillInline(p, text) {
      p.textContent = '';
      const lines = String(text || '').split('\n');
      for (let li = 0; li < lines.length; li++) {
        if (li) p.appendChild(document.createElement('br'));
        const segs = lines[li].split(/\*\*([^*\n]{1,120}?)\*\*/);
        for (let si = 0; si < segs.length; si++) {
          if (!segs[si]) continue;
          if (si % 2) {
            const b = document.createElement('strong');
            b.textContent = segs[si];
            p.appendChild(b);
          } else {
            p.appendChild(document.createTextNode(segs[si]));
          }
        }
      }
    }

    renderTyping() {
      const el = document.createElement('div');
      el.className = 'curator__msg curator__msg--bot curator__msg--typing';
      for (let i = 0; i < 3; i++) {
        const dot = document.createElement('span');
        dot.className = 'curator__dot';
        dot.setAttribute('aria-hidden', 'true');
        el.appendChild(dot);
      }
      const label = document.createElement('span');
      label.className = 'visually-hidden';
      label.textContent = this.strings.typing || '';
      el.appendChild(label);
      this.messagesEl.appendChild(el);
      this.scrollToEnd(true);
      return el;
    }

    validLinks(raw) {
      const out = [];
      if (!Array.isArray(raw)) return out;
      for (const item of raw) {
        if (!item || typeof item !== 'object') continue;
        const t = clean(item.t, 60);
        const u = typeof item.u === 'string' ? item.u : '';

        if (!t || (u !== DESCRIBE_LINK && !/^\/(?:pages|products|collections)\/[a-z0-9][a-z0-9\-_/]*$/i.test(u))) continue;
        if (out.some((x) => x.u.toLowerCase() === u.toLowerCase())) continue;
        out.push({ t, u });
        if (out.length >= 4) break;
      }
      return out;
    }

    replyLinks(text, serverLinks) {
      const server = this.validLinks(serverLinks);
      const t = String(text || '').replace(/\s+/g, ' ').trim();
      if (!t) return server;
      const questions = t.match(/[^.!?]*\?/g);
      const last = questions && questions.length ? questions[questions.length - 1] : '';
      const at = last ? t.lastIndexOf(last) : -1;
      const body = at > -1 ? t.slice(0, at) + ' ' + t.slice(at + last.length) : t;
      const key = (u) => String(u || '').toLowerCase();
      const offers = this.proposedLinks(last);
      const bodyLinks = this.proposedLinks(body);
      const customer = typeof this.lastUserQuestion === 'function' ? this.proposedLinks(this.lastUserQuestion()) : [];
      const offered = new Set(offers.map((l) => key(l.u)));
      const named = new Set(offers.concat(bodyLinks, customer).map((l) => key(l.u)));
      const cands = [];
      const seen = new Map();
      const add = (link, rank, order) => {
        const k = key(link.u);
        const prev = seen.get(k);
        if (prev) {
          if (rank < prev.rank) prev.rank = rank;
          return;
        }
        const c = { link, rank, order };
        seen.set(k, c);
        cands.push(c);
      };
      server.forEach((l, i) => {
        const k = key(l.u);
        add(l, offered.has(k) ? 0 : /^\/collections\//.test(k) ? 1 : named.has(k) ? 2 : 4, i);
      });
      offers.forEach((l, i) => add(l, 0, 100 + i));
      bodyLinks.forEach((l, i) => add(l, 3, 200 + i));
      const kept = cands.slice().sort((a, b) => (a.rank - b.rank) || (a.order - b.order)).slice(0, 4);
      kept.sort((a, b) => a.order - b.order);
      return this.validLinks(kept.map((c) => c.link));
    }

    proposedLinks(segment) {
      const hits = [];
      const src = String(segment || '');
      if (!src.trim()) return hits;
      const sentences = src.match(/[^.!?]+[.!?]*/g) || [];
      let offset = 0;
      for (const sentence of sentences) {
        const base = src.indexOf(sentence, offset);
        offset = base + sentence.length;
        for (const rule of this.replyLinkRules()) {
          if (!rule.t) continue;
          if (rule.veto && rule.veto.test(sentence) && !(rule.keep && rule.keep.test(sentence))) continue;
          const m = rule.re.exec(sentence);
          if (!m) continue;
          const span = this.clauseSpan(sentence, m.index, m.index + m[0].length);
          const clause = sentence.slice(span.from, span.to);
          if (this.negatedHit(clause, m.index - span.from, m.index + m[0].length - span.from)) continue;
          if (rule.skip && rule.skip.test(rule.skipSentence ? sentence : clause)) continue;
          hits.push({ t: rule.t, u: rule.u, ask: rule.ask || '', at: base + m.index });
        }
      }
      hits.sort((a, b) => a.at - b.at);
      return hits.map((h) => ({ t: h.t, u: h.u, ask: h.ask }));
    }

    negatedHit(clause, start, end) {
      const c = String(clause || '').replace(REPLY_NEG_EXEMPT_RE, (m) => ' '.repeat(m.length));
      const before = c.slice(0, Math.max(0, start)).split(/\s+/).filter(Boolean).slice(-REPLY_NEGATION_WINDOW).join(' ');
      if (REPLY_NEGATION_RE.test(before)) return true;
      return REPLY_NEGATION_AFTER_RE.test(c.slice(Math.max(0, end)));
    }

    replyLinkRules() {
      const S = this.strings || {};
      const cols = Array.isArray(this.collections) ? this.collections : [];
      if (this._linkRules && this._linkRulesFor === cols) return this._linkRules;
      const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const rules = REPLY_LINK_RULES.map((r) => Object.assign({}, r, { t: clean(S[r.key], 60) }));
      if (S.linkCollection) {
        for (const col of cols) {
          if (!col || !col.h || !col.t || !/^[a-z0-9][a-z0-9\-_]*$/i.test(col.h)) continue;
          const short = col.t.replace(CATEGORY_SUFFIX_RE, '').trim() || col.t;
          if (short.length < 3) continue;
          const words = (s) => esc(s).replace(/\s+/g, '\\s+');

          rules.push({
            t: clean(S.linkCollection.replace('%collection%', short), 60),
            u: '/collections/' + col.h,
            re: new RegExp('\\b' + words(col.t) + '\\b|\\b' + words(short)
              + 's?(?:\\s*,?\\s+(?:and|or|&)\\s+(?:[a-z\'’-]+\\s+){0,2}?[a-z\'’-]+)?\\s+collections?\\b', 'i'),
          });
        }
      }
      this._linkRules = rules;
      this._linkRulesFor = cols;
      return rules;
    }

    clauseAround(sentence, start, end) {
      const span = this.clauseSpan(sentence, start, end);
      return sentence.slice(span.from, span.to);
    }

    clauseSpan(sentence, start, end) {
      let from = 0;
      let to = sentence.length;
      REPLY_CLAUSE_BREAK_RE.lastIndex = 0;
      let m;
      while ((m = REPLY_CLAUSE_BREAK_RE.exec(sentence)) !== null) {
        if (m.index + m[0].length <= start) from = m.index + m[0].length;
        else if (m.index >= end) { to = m.index; break; }
      }
      return { from, to };
    }

    replyMentions(text, re, veto) {
      for (const sentence of String(text || '').match(/[^.!?]+[.!?]*/g) || []) {
        const m = re.exec(sentence);
        if (!m) continue;
        const span = this.clauseSpan(sentence, m.index, m.index + m[0].length);
        const clause = sentence.slice(span.from, span.to);
        if (this.negatedHit(clause, m.index - span.from, m.index + m[0].length - span.from)) continue;
        if (veto && veto.test(clause)) continue;
        return true;
      }
      return false;
    }

    renderLinks(links, afterEl) {
      const chips = this.validLinks(links);
      if (!chips.length) return;
      const wrap = document.createElement('div');
      wrap.className = 'curator__links';
      wrap.setAttribute('role', 'group');
      for (const link of chips) {
        const a = document.createElement('a');
        a.href = link.u;
        a.addEventListener('click', () => this.fireEvent('link', link.u));
        const thumb = LINK_THUMBS[link.u.replace(/\/+$/, '').toLowerCase()];
        if (thumb) {
          a.className = 'curator__link curator__link--card';
          const img = document.createElement('img');
          img.className = 'curator__link-thumb';
          img.src = thumb;
          img.alt = '';
          img.loading = 'lazy';
          img.decoding = 'async';
          img.width = 84;
          img.height = 56;

          img.onerror = () => {
            a.classList.remove('curator__link--card');
            img.remove();
          };
          const label = document.createElement('span');
          label.className = 'curator__link-label';
          label.textContent = link.t;
          a.append(img, label);
        } else {
          a.className = 'curator__link';
          a.textContent = link.t;
        }
        wrap.appendChild(a);
      }
      if (afterEl && afterEl.parentNode === this.messagesEl) afterEl.after(wrap);
      else this.messagesEl.appendChild(wrap);
      this.scrollToEnd();
    }

    validSuggests(raw) {
      const out = [];
      if (!Array.isArray(raw)) return out;
      for (const item of raw) {
        const t = clean(typeof item === 'string' ? item : (item && item.t), 60);
        if (!t) continue;
        if (out.some((x) => x.toLowerCase() === t.toLowerCase())) continue;
        out.push(t);
        if (out.length >= 3) break;
      }
      return out;
    }

    optionOk(str) {
      const v = String(str || '');
      if (v.length < 3 || v.length > 36) return false;
      if (v.split(/\s+/).length > 5) return false;
      if (!/[a-z]/i.test(v)) return false;

      if (/^(?:is|are|was|were|do|does|did|would|will|shall|should|can|could|may|might|have|has|had|which|what|how|where|who|whom|whose|why|when|if|since|so|then|there|here|that|this|these|those)\b/i.test(v)) return false;
      if (/\b(?:you|your|yours|i|me|my|we|us|our|it|its|they|them|their)\b/i.test(v)) return false;

      if (/^(?:get|start|begin|narrow|pivot|explore|browse|keep|make|take|go|have|show|tell|help|find|look|see|say|pick|choose|stick|anchor|fill|cover|brighten|hang|complement|decorate|match)\b/i.test(v)) return false;

      if (/\s+or\s+/i.test(v)) return false;
      if (/,\s+(?:a|an|the)\s/i.test(v)) return false;

      if (/^(?:specific|particular|certain)\b/i.test(v)) return false;
      if (/^(?:different|similar|other|same|new|else|both|either|neither|any|all|more|less)$/i.test(v)) return false;

      if (/[()\[\]{}]/.test(v)) return false;
      if (/\b(?:feel|feels|fit|fits|work|works|sound|sounds|speak|speaks|appeal|appeals|land|lands|suit|suits|match|matches|need|needs|help|helps)\b/i.test(v)) return false;
      return true;
    }

    optionLabel(part) {
      let v = String(part || '').replace(/^[\s,;:–—-]+/, '').replace(/[\s,;:.!?–—-]+$/, '').trim();
      let prev = '';
      while (v && v !== prev) {
        prev = v;
        v = v.replace(/^(?:and|or|but|maybe|perhaps|possibly|even|just|really|rather|more|most|something|somewhere|anything|one|a|an|the|some|of|like|with|for|in|on|at|from|by|about|into|onto|than|as|to)\s+/i, '').trim();
      }

      v = v.replace(/^(?:bit|lot|little|touch|kind|sort|type|hint|sense)\s+of\s+/i, '')
        .replace(/^(?:focused|centred|centered|based|built|filled)\s+(?:on|around|with)\s+/i, '')
        .replace(/^(?:full|rich)\s+of\s+/i, '')
        .trim();

      const beforeDest = v;
      v = v.replace(/\s+\b(?:for|in|on|at|to|with)\b\s+(?:the|a|an|your|her|his|their|my|our|this|that)\b.*$/i, '')
        .replace(/[\s,;:.!?–—-]+$/, '')
        .trim();
      const destCut = v !== beforeDest;

      const rel = v.replace(/\s+(?:that|which|who)\s+.*$/i, '').trim();
      if (rel !== v && rel.split(/\s+/).length >= 2) v = rel;
      const purpose = v.replace(/\s+to\s+(?!(?:the|a|an|your|my|our|their|his|her|this|that|these|those|it|you|me|us|them|him)\b)[a-z]+\b.*$/i, '').trim();
      if (purpose !== v && purpose.split(/\s+/).length >= 2) v = purpose;
      v = v.replace(/[\s,;:.!?–—-]+$/, '').trim();

      if (destCut && PARTICIPLE_END_RE.test(v) && !NOT_PARTICIPLE_RE.test(v)) return '';

      if (GENERIC_OPTION_RE.test(v)) return '';
      if (!this.optionOk(v)) return '';
      return (v.charAt(0).toUpperCase() + v.slice(1)).split(RANGE_DASH).join('–');
    }

    optionFromStem(part) {
      let v = String(part || '').trim();

      const punct = Math.max(v.lastIndexOf('—'), v.lastIndexOf('–'), v.lastIndexOf(':'));
      if (punct > -1) v = v.slice(punct + 1);

      const LEAD = /\b(?:for|toward|towards|between|about|prefer|prefers|preferring|want|wants|see|explore|considering|choosing|picking|after|into|like|drawn to|leaning|start(?:ing)?\s+with|begin(?:ning)?\s+with|feel|feels|feeling)\b\s+/gi;

      const trimmed = v.replace(/\s+\b(?:for|in|on|at)\b\s+(?:the|a|an|your|her|his|their|my|our)\b[^,]*$/i, '');
      LEAD.lastIndex = 0;
      if (trimmed !== v && LEAD.test(trimmed)) v = trimmed;

      const rel = /\s+(?:that|which|who)\s+/i.exec(v);
      if (rel) {
        LEAD.lastIndex = 0;
        if (LEAD.test(v.slice(0, rel.index))) v = v.slice(0, rel.index);
      }
      let cut = -1;
      let m;
      LEAD.lastIndex = 0;
      while ((m = LEAD.exec(v)) !== null) cut = m.index + m[0].length;
      if (cut > -1) v = v.slice(cut);
      return this.optionLabel(v);
    }

    cardOptions(question, cards) {
      const q = String(question || '');
      if (!Array.isArray(cards) || cards.length < 2) return [];
      if (!/\b(?:which|what|any|one)\b[^?]*\b(?:these|those)\b/i.test(q)) return [];
      const out = [];
      for (const card of cards) {
        const title = card && typeof card.t === 'string' ? card.t.replace(/\s+/g, ' ').trim() : '';
        if (!title || title.length > 40) continue;
        if (out.some((x) => x.toLowerCase() === title.toLowerCase())) continue;
        out.push(title);
        if (out.length >= 3) break;
      }
      return out.length >= 2 ? out : [];
    }

    guideOptions(question) {
      let v = String(question || '').replace(/[?？]+\s*$/, '').trim();
      if (!v) return [];

      v = v.replace(/(\d)\s*[–-]\s*(?=\d)/g, '$1' + RANGE_DASH);

      const restart = /\s(?:Do|Does|Would|Are|Is|Which|What|Should|Could|Can|Shall|Will)\s+(?:you|we|I|it|this|these|they)\b/.exec(v);
      if (restart && restart.index > 0) v = v.slice(restart.index + 1);
      let bracketed = false;

      v = v.replace(/^(?:to\s+[a-z]+(?:\s+[a-z]+){0,3}|for\s+[a-z][^,]{0,40}|since[^,]{0,70}|if[^,]{0,70}|because[^,]{0,70}|while[^,]{0,70}|given[^,]{0,70}|now that[^,]{0,70}|also|and|but|so)\s*,\s+/i, '').trim();

      const fenced = v.match(/[—–]\s*([^—–]{4,140}?)\s*[—–]/);
      if (fenced && /\s+or\s+/i.test(fenced[1])) v = fenced[1];
      else {

        const dash = Math.max(v.lastIndexOf('—'), v.lastIndexOf('–'));
        if (dash > -1 && /\s+or\s+/i.test(v.slice(dash + 1))) v = v.slice(dash + 1).trim();

        const paren = v.match(/\(([^)]{4,120})\)/);
        if (paren && /,|\s+or\s+/i.test(paren[1])) { v = paren[1]; bracketed = true; }
        else v = v.replace(/\s*\([^)]*\)\s*/g, ' ').replace(/\s+/g, ' ').trim();
      }

      if (!/\s+or\s+/i.test(v) && !(bracketed && v.includes(','))) return [];
      const tidy = (arr) => arr.map((p) => p.trim()).filter(Boolean);
      let labels;
      if (bracketed && !/\s+or\s+/i.test(v)) {
        const items = tidy(v.split(/\s*,\s*/));
        labels = items.map((p, i) => (i === 0 ? this.optionFromStem(p) : this.optionLabel(p)));
      } else {

        const at = v.toLowerCase().lastIndexOf(' or ');
        if (at < 0) return [];
        const head = v.slice(0, at).replace(/[\s,;]+$/, '');
        const tail = v.slice(at + 4);

        const heads = tidy(head.split(/\s*,\s*/));

        for (let i = heads.length - 2; i >= 0; i--) {
          if (/\b(?:a|an|the|some|more)\s+(?:warmer|cooler|softer|bolder|brighter|darker|lighter|calmer|richer|deeper|quieter|simpler|larger|smaller|bigger|moodier|airier|earthier|bold|bright|soft|warm|cool|calm|dark|light|deep|rich|quiet|vibrant|colou?rful|muted|moody|airy|earthy|golden|gentle|dramatic|subtle|simple|serene|striking|playful)$/i.test(heads[i])) {
            heads.splice(i, 2, heads[i] + ', ' + heads[i + 1]);
          }
        }
        let headLabels = [this.optionFromStem(head)];
        if (/,\s*(?:or|and)\s+/i.test(v) && heads.length > 1) {
          const each = heads.map((p, i) => (i === 0 ? this.optionFromStem(p) : this.optionLabel(p)));
          if (each.every(Boolean)) headLabels = each;
        }
        labels = headLabels.concat([this.optionLabel(tail)]);
      }
      const opts = [];
      for (const label of labels) {
        if (opts.length >= 3) break;
        if (label && !opts.some((x) => x.toLowerCase() === label.toLowerCase())) opts.push(label);
      }

      return opts.length >= 2 ? opts : [];
    }

    actionOptions(question) {
      let v = String(question || '').replace(/[?？]+\s*$/, '').replace(/\s+/g, ' ').trim();
      if (!v) return [];

      v = v.replace(/(\d)\s*[–-]\s*(?=\d)/g, '$1' + RANGE_DASH);
      const opener = () => new RegExp(ACTION_OPENER_RE.source, 'gi');

      let dash = -1;
      let dashLen = 0;
      for (const [at, len] of [[v.lastIndexOf('—'), 1], [v.lastIndexOf('–'), 1], [v.lastIndexOf(' - '), 3]]) {
        if (at > dash) { dash = at; dashLen = len; }
      }
      if (dash > -1) {
        const after = v.slice(dash + dashLen).trim();
        const before = v.slice(0, dash).trim();
        if (opener().test(after)) v = after;

        else if (/^(?:what|which|where|how|who|when)\b/i.test(after) && !/\s+or\s+/i.test(before)) return [];
        else v = before;
      }
      const marks = [];
      const re = opener();
      let m;
      while ((m = re.exec(v)) !== null) {

        const clauseStart = Math.max(v.lastIndexOf(',', m.index), v.lastIndexOf(';', m.index), v.lastIndexOf(':', m.index));
        if (/\b(?:what|which|where|how|who|whom|when|why|whatever)\b/i.test(v.slice(clauseStart + 1, m.index))) continue;

        marks.push({ at: m.index, end: m.index + m[0].length, curator: /\bme\s+to\b|\bi\b/i.test(m[0]) });
      }
      if (!marks.length) return [];

      if (/\b(?:would|do)\s+you\s+(?:prefer|like|want)\s+(?!to\b|me\b)\S/i.test(v.slice(0, marks[0].at))) return [];
      const verbs = ACTION_VERB_RE.source.replace(/^\^/, '');
      const lead = '(?:else\\s+|perhaps\\s+|maybe\\s+|just\\s+|even\\s+|rather\\s+|to\\s+)?';
      const orSplit = new RegExp('\\s*,?\\s+or\\s+(?=' + lead + verbs + ')', 'i');
      const commaSplit = new RegExp('\\s*,\\s+(?=' + lead + verbs + ')', 'i');

      const questionSplit = /\s*,?\s+or\s+(?=(?:do|would|are|is|have|did|should|could|can|will|shall)\s+you\b)/i;
      const pieces = [];
      for (let i = 0; i < marks.length; i++) {

        const span = v.slice(marks[i].end, i + 1 < marks.length ? marks[i + 1].at : v.length)
          .replace(/[\s,;]*\b(?:or|and)\s*$/i, '')
          .split(questionSplit)[0];
        let parts = span.split(orSplit);

        if (parts.length > 1) parts = [].concat(...parts.map((p) => p.split(commaSplit)));
        for (const p of parts) pieces.push({ text: p, curator: marks[i].curator });
      }
      const rules = this.replyLinkRules();
      const out = [];
      let actions = 0;
      let unvoiced = 0;
      let tooLong = 0;
      for (const piece of pieces) {

        if (rules.some((r) => r.re.test(piece.text))) { actions++; continue; }
        const r = this.voiceAction(piece.text, piece.curator);
        if (r.reason === 'noverb') continue;
        actions++;
        if (!r.label) {

          if (r.reason === 'long' || r.reason === 'shape') unvoiced++;
          if (r.reason === 'long') tooLong++;
          continue;
        }
        if (out.length < 3 && !out.some((x) => x.toLowerCase() === r.label.toLowerCase())) out.push(r.label);
      }
      if (unvoiced && actions > 1) return [];
      if (!out.length && actions === 1 && tooLong === 1) {
        const yes = [];
        yes.yesOnly = true;
        return yes;
      }
      return out;
    }

    customerVoice(raw, curatorActs) {
      return this.voiceAction(raw, curatorActs).label;
    }

    voiceAction(raw, curatorActs) {
      const no = (reason) => ({ label: '', reason });
      let v = String(raw || '').replace(/^[\s,;:–—-]+/, '').replace(/[\s,;:.!?–—-]+$/, '').trim();
      let prev = '';
      while (v && v !== prev) {
        prev = v;
        v = v.replace(/^(?:or|and|then|else|perhaps|maybe|just|even|rather|also|simply|to|go\s+ahead\s+and)\s+/i, '').trim();
      }
      if (!ACTION_VERB_RE.test(v)) return no('noverb');

      if (!curatorActs && ACTION_CUSTOMER_INPUT_RE.test(v)) return no('input');

      if (/^upload\b/i.test(v)) return no('input');
      if (ACTION_COMMERCE_RE.test(v)) return no('commerce');
      if (/[()[\]{}"“”?]/.test(v)) return no('shape');

      if (/\b(?:i|me|myself)\b|\bi['’](?:d|ll|m|ve)\b/i.test(v)) return no('shape');
      const words = v.split(' ');
      for (let i = 0; i < words.length; i++) {
        const parts = /^([a-z'’]+)(.*)$/i.exec(words[i]);
        if (!parts) continue;
        const core = parts[1].toLowerCase();
        const tail = parts[2];
        const next = words[i + 1] || '';
        let swap = null;
        if (core === 'my') swap = 'your';
        else if (core === 'mine') swap = 'yours';
        else if (core === 'your') swap = 'my';
        else if (core === 'yours') swap = 'mine';
        else if (core === 'yourself') swap = 'myself';

        else if (core === 'our' && !tail && !OUR_SHARED_NEXT_RE.test(next)) swap = 'your';
        else if (/^you['’]re$/.test(core)) swap = 'I’m';
        else if (/^you['’](?:ve|d|ll)$/.test(core)) swap = 'I' + parts[1].slice(3);
        else if (core === 'you') {

          if (!tail && YOU_SUBJECT_NEXT_RE.test(next)) {
            swap = 'I';
            if (/^are\b/i.test(next)) words[i + 1] = next.replace(/^are/i, 'am');
            else if (/^were\b/i.test(next)) words[i + 1] = next.replace(/^were/i, 'was');
          } else swap = 'me';
        }
        if (swap) words[i] = swap + tail;
      }
      v = words.join(' ');

      const embedded = /^(?:tell|show)\s+me\s+(?:which|what|how|whether|where|who)\b/i.test(v);

      const fitClause = /\s+(?:that|which)\s+(?:fits?|suits?|matches|match|complements?|works?\s+(?:for|in|with)|goes?\s+with)\s+((?:my|the)\s+[a-z-]+(?:\s+[a-z-]+)?)$/i;
      if (embedded) {  }
      else if (fitClause.test(v)) v = v.replace(fitClause, ' for $1');

      else {
        v = v.replace(/\s+(?:which|who|whose)\s+.*$/i, '');
        const thatRe = /(\S+)\s+that\s/gi;
        let tm;
        while ((tm = thatRe.exec(v)) !== null) {
          if (/^(?:in|with|into|of|on|for|to|from|like|at|by|about|across|toward|towards|through|under|over|around|onto|than|all)$/i.test(tm[1]) || ACTION_VERB_RE.test(tm[1])) continue;
          v = v.slice(0, tm.index + tm[1].length);
          break;
        }
      }
      v = v.replace(/\s+(?:first|now|right\s+now|today|then|together)$/i, '').trim();
      const fits = (s) => s.length <= ACTION_MAX_CHARS && s.split(/\s+/).length <= ACTION_MAX_WORDS;
      const wh = /\b(?:how|what|where|whether|if|why|which)\b/i;

      let floor = 0;
      if (ACTION_RESULT_VERB_RE.test(v)) {
        const r = /\s+(?:into|to|in)\s+/i.exec(v);
        floor = r ? r.index + r[0].length : v.length;
      }

      const prep = /\s+(?:in|with|for|from|at|on|across|throughout|around|inside|into|to)\s+(?:a|an|the|that|this|those|these|my|your|our|some|same|similar|each|every|one|other|another|different)\b/gi;
      for (let n = 0; n < 2 && !fits(v) && !embedded && !wh.test(v); n++) {
        let cut = -1;
        let pm;
        prep.lastIndex = 0;
        while ((pm = prep.exec(v)) !== null) cut = pm.index;
        if (cut < floor) break;
        const shorter = v.slice(0, cut).trim();
        if (shorter.split(/\s+/).length < 3) break;
        v = shorter;
      }
      const dangling = (s) => /\b(?:a|an|the|of|and|or|to|how|what|which|some|more|few|couple|that|this|these|those|with|for|in|on|at|by|from|into|like|than|as|so|if)$/i.test(s)
        && !/\blike\s+(?:this|these|those|that)$/i.test(s);
      if (!fits(v)) {
        if (embedded) return no('shape');
        if (floor) return no('long');
        const alt = this.shortAction(v);
        if (!alt || !fits(alt) || dangling(alt) || wh.test(alt)) return no('long');
        v = alt;
      }
      if (v.split(/\s+/).length < 2) return no('shape');

      if (dangling(v)) return no('shape');

      if (/^\S+\s+(?:me|you|it|them|this|that|one|those|these)$/i.test(v)) return no('shape');
      return { label: (v.charAt(0).toUpperCase() + v.slice(1)).split(RANGE_DASH).join('–'), reason: '' };
    }

    shortAction(v) {
      const s = String(v || '');
      let m = /^(\w+)\s+(?:the|my|this|that)\s+(?:space|room|wall|walls|area|corner)\s+(with\s+.+)$/i.exec(s);
      if (m) return m[1] + ' ' + m[2];
      m = /^(\w+)\s+(?:some|a\s+few|any|more|one|all|a\s+couple)\s+of\s+(those|these)\s+(.+)$/i.exec(s);
      if (m) return m[1] + ' ' + m[2] + ' ' + m[3];
      m = /^(see|view|explore|preview|show\s+me)\s+how\s+(?:a|an|the)\s+((?:[a-z-]+\s+)?)([a-z-]+)\s+(?:might|would|could|will|can|may)\b/i.exec(s);
      if (m) {
        const noun = m[3];
        if (!/^(?:landscape|seascape|cityscape|skyline|abstract|floral|piece|canvas|painting|print|portrait|scene|botanical|artwork|design|collage|photograph|study|triptych|diptych|set|pair)$/i.test(noun)) return '';
        const plural = /(?:s|x|z|ch|sh)$/i.test(noun) ? noun + 'es' : /[^aeiou]y$/i.test(noun) ? noun.slice(0, -1) + 'ies' : noun + 's';
        return m[1] + ' ' + m[2] + plural;
      }
      const cut = /\s+(?:of\s+how|how|focused\s+on|centred\s+on|centered\s+on|featuring|with|from|in|that|which|to)\b/i.exec(s);
      if (cut) {
        const head = s.slice(0, cut.index).trim();
        if (head.split(/\s+/).length >= 2 && !/\b(?:how|what|which)\b/i.test(head)) return head;
      }
      return '';
    }

    splitGuide(text) {
      const t = String(text || '').replace(/\s+$/, '');
      if (!/[?？]$/.test(t)) return null;
      const m = t.match(/(?:[.!?…]\s+|\n\s*)([^.!?\n][^.!?]*[?？])$/);
      if (!m) return null;
      const guide = m[1].trim();
      const body = t.slice(0, t.length - m[1].length).replace(/\s+$/, '');
      if (guide.length < 12 || guide.length > 220 || body.length < 24) return null;

      if (!/^(which|what|would|do|does|are|is|should|how|where|who|whose|can|could|shall|may|ready)\b/i.test(guide)) return null;
      return { body, guide };
    }

    normSuggest(s) {
      return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    }

    deriveSuggests(text, cards, ctx) {
      const S = this.strings || {};
      const out = [];
      const hasCards = Array.isArray(cards) && cards.length > 0;
      const t = String(text || '').replace(/\s+/g, ' ').trim();
      const links = ctx && Array.isArray(ctx.links) ? ctx.links : [];
      const linked = links.map((l) => String(l && l.u || '').toLowerCase());
      const hasArt = !!(ctx && ctx.art);

      const asked = [];
      const userTexts = [];
      let turnIndex = 0;
      let lastSg = [];
      for (const m of this.transcript) {
        if (m.r === 'u') {
          asked.push(this.normSuggest(m.c));
          userTexts.push(String(m.c || '').toLowerCase());
        } else if (m.r === 'a') {
          turnIndex++;
          lastSg = Array.isArray(m.sg) ? m.sg.map((x) => this.normSuggest(x)) : [];
        }
      }
      const allUser = userTexts.join('  ');
      const lastAsked = asked.length ? asked[asked.length - 1] : '';

      const wasAsked = (norm) => {
        for (const a of asked) {
          if (!a) continue;
          if (a === norm) return true;
          if (norm.length >= 12 && a.length >= 12 && (a.includes(norm) || norm.includes(a))) return true;
        }
        return false;
      };

      const usable = (label, reuse, proposed) => {
        const v = clean(label, 60);
        if (!v) return '';
        const norm = this.normSuggest(v);
        if (!norm) return '';
        if (!proposed && lastSg.includes(norm)) return '';
        if (reuse ? norm === lastAsked : wasAsked(norm)) return '';
        if (out.some((x) => x.toLowerCase() === v.toLowerCase())) return '';
        return v;
      };

      const questions = t.match(/[^.!?]*\?/g);
      const last = questions && questions.length ? questions[questions.length - 1].trim() : '';
      let answered = false;
      if (last) {
        for (const opt of this.guideOptions(last)) {
          const v = usable(opt, true, true);
          if (v) out.push(v);
        }
        answered = out.length > 0;

        if (!answered) {
          const acts = this.actionOptions(last);
          for (const opt of acts) {
            if (out.length >= 3) break;
            const v = usable(opt, true, true);
            if (v) out.push(v);
          }
          if (acts.yesOnly && S.suggestYes) {
            const yes = clean(S.suggestYes, 60);
            if (yes) out.push(yes);
          }
          answered = out.length > 0;
        }
      }
      const actionChips = out.slice();

      if (S.suggestCustomText && out.length < 3 && this.replyMentions(t, CUSTOM_TEXT_RE)) {
        const v = usable(S.suggestCustomText, false, true);
        if (v) out.push(v);
      }

      if (S.suggestPaintOriginal && !hasArt && out.length < 3 && !out.some((c) => /\bpaint/i.test(c))
        && this.replyMentions(t, PAINT_HERE_RE, /\bstudio\b|\bwritten\s+description\b/i)) {
        const v = usable(S.suggestPaintOriginal, true, true);
        if (v) out.push(v);
      }

      if (ctx && Array.isArray(ctx.links)) {
        for (const page of this.proposedLinks(t)) {
          if (out.length >= 3) break;
          if (!page.ask || !S[page.ask] || linked.includes(String(page.u).toLowerCase())) continue;
          const v = usable(S[page.ask], false, true);
          if (v) out.push(v);
        }
      }

      if (last && !answered) {
        for (const opt of this.cardOptions(last, cards)) {
          if (out.length >= 3) break;
          const v = usable(opt, true, true);
          if (v) out.push(v);
        }
      }

      if (!hasCards) {
        const proposedLinked = !!(ctx && Array.isArray(ctx.links))
          && this.proposedLinks(t).some((p) => linked.includes(String(p.u).toLowerCase()));
        if (out.length || proposedLinked) return out.slice(0, 3);
      }

      const candidates = [];

      const offersMore = actionChips.some((c) => /^(?:see|show|explore|browse|find|view|pull|check)\b/i.test(c)
        && /\bmore\b|\b(?:other|a few|some|those|these)\s+(?:[\w-]+,?\s+){0,2}(?:options|pieces|ones|artworks|canvases|examples)\b/i.test(c));
      if (hasCards && S.suggestMoreLike && !offersMore) candidates.push({ t: S.suggestMoreLike, reuse: true });

      const roomRe = (key) => (ROOM_IMAGE_RULES.find((r) => r.key === key) || { re: null }).re;
      const lastRooms = ROOM_IMAGE_RULES.filter((r) => r.re.test(last)).length;
      const picksRoom = lastRooms >= 2 && /\bor\b/i.test(last);
      if (S.suggestRoomNamed && !picksRoom) {
        const rooms = [
          ['living', S.roomLiving],
          ['bedroom', S.roomBedroom],
          ['office', S.roomOffice],
          ['dining', S.roomDining],
          ['gym', S.roomGym],
          ['kitchen', S.roomKitchen],
        ].filter(([key, label]) => {
          if (!label || allUser.includes(key) || key === (this.activeRoom || '')) return false;
          const re = roomRe(key);
          if (re && (re.test(t) || out.some((c) => re.test(c)))) return false;
          return true;
        });
        if (rooms.length) {
          const label = rooms[turnIndex % rooms.length][1];
          candidates.push({ t: S.suggestRoomNamed.replace('%room%', label.toLowerCase()), reuse: false });
        }
      }

      if (S.suggestCategoryNamed && Array.isArray(this.collections) && this.collections.length) {

        const fresh = this.collections.filter((c) => c && c.t && !allUser.includes(c.t.toLowerCase())
          && !linked.includes(('/collections/' + c.h).toLowerCase()));
        if (fresh.length) {
          const lowerReply = t.toLowerCase();
          const mentioned = fresh.find((c) => lowerReply.includes(c.t.toLowerCase()));
          const pick = mentioned || fresh[turnIndex % fresh.length];
          const title = pick.t.replace(CATEGORY_SUFFIX_RE, '').trim() || pick.t;
          candidates.push({ t: S.suggestCategoryNamed.replace('%category%', title), reuse: false });
        }
      }

      const oneTime = [];
      if (hasCards) {
        if (S.suggestTopPick) oneTime.push(S.suggestTopPick);
        if (S.suggestBudget) oneTime.push(S.suggestBudget);
        if (S.suggestSizes) oneTime.push(S.suggestSizes);
      }

      if (S.suggestCustom && !PHOTO_LINK_PATHS.some((p) => linked.includes(p))) oneTime.push(S.suggestCustom);
      if (S.suggestHistory) oneTime.push(S.suggestHistory);
      if (S.suggestShipping) oneTime.push(S.suggestShipping);
      for (let i = 0; i < oneTime.length; i++) {
        candidates.push({ t: oneTime[(i + turnIndex) % oneTime.length], reuse: false });
      }

      if (!hasCards) {
        if (S.suggestBrowse) candidates.push({ t: S.suggestBrowse, reuse: false });
        if (S.suggestRecommend) candidates.push({ t: S.suggestRecommend, reuse: true });
      }
      if (S.suggestRoom) candidates.push({ t: S.suggestRoom, reuse: true });

      for (const cand of candidates) {
        if (out.length >= 3) break;
        const v = usable(cand.t, cand.reuse);
        if (v) out.push(v);
      }
      return out.slice(0, 3);
    }

    renderSuggests(list, afterEl) {
      const chips = this.validSuggests(list);
      if (!chips.length) return;
      const wrap = document.createElement('div');
      wrap.className = 'curator__suggests';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', (this.strings && this.strings.suggestionsLabel) || '');
      for (const q of chips) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'curator__suggest';
        b.setAttribute('data-curator-suggest', '');
        b.textContent = q;
        wrap.appendChild(b);
      }
      if (afterEl && afterEl.parentNode === this.messagesEl) afterEl.after(wrap);
      else this.messagesEl.appendChild(wrap);
      this.scrollToEnd();
    }

    renderCards(cards, afterEl) {
      const wrap = document.createElement('div');
      wrap.className = 'curator__cards';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', this.strings.recommendationsLabel || '');

      for (const card of cards.slice(0, MAX_CARDS)) {
        const record = this.recordForCard(card);
        if (record) this.productIndex.set(record.h, record);
        const item = document.createElement('article');
        item.className = 'curator__card';

        const media = document.createElement('a');
        media.className = 'curator__card-media';
        media.href = '/products/' + encodeURIComponent(card.h);
        media.tabIndex = -1;
        media.setAttribute('aria-hidden', 'true');
        media.addEventListener('click', () => {
          if (record) this.rememberRecent(record);
        });
        if (card.img) {
          const img = document.createElement('img');
          img.src = sized(card.img, 400);
          img.alt = '';
          img.loading = 'lazy';
          img.decoding = 'async';
          img.width = 400;
          img.height = 500;
          media.appendChild(img);
        }
        item.appendChild(media);

        const body = document.createElement('div');
        body.className = 'curator__card-body';

        const title = document.createElement('p');
        title.className = 'curator__card-title';
        title.textContent = card.t;
        body.appendChild(title);

        const price = document.createElement('p');
        price.className = 'curator__card-price';

        price.textContent = card.min
          ? interp(this.strings.priceFrom || '[price]', { price: money(card.min) })
          : clean(card.p, 80);
        body.appendChild(price);

        const actions = document.createElement('div');
        actions.className = 'curator__card-actions';

        const view = document.createElement('a');
        view.className = 'curator__card-view';
        view.href = '/products/' + encodeURIComponent(card.h);
        view.textContent = this.strings.viewArtwork || '';
        view.addEventListener('click', () => {
          if (record) this.rememberRecent(record);
          this.fireEvent('card_view', card.h);
        });
        actions.appendChild(view);

        const favorite = document.createElement('button');
        favorite.type = 'button';
        favorite.className = 'curator__card-favorite';
        favorite.dataset.curatorFavorite = card.h;
        const saved = this.isFavorite(card.h);
        favorite.classList.toggle('is-active', saved);
        favorite.setAttribute('aria-pressed', String(saved));
        favorite.setAttribute(
          'aria-label',
          (saved ? this.strings.unfavorite || 'Remove from favorites' : this.strings.favorite || 'Save to favorites') + ' — ' + card.t
        );
        favorite.textContent = saved ? '♥' : '♡';
        favorite.addEventListener('click', () => {
          if (record) this.toggleFavorite(record);
        });
        actions.appendChild(favorite);

        const add = document.createElement('button');
        add.type = 'button';
        add.className = 'curator__card-add';
        add.setAttribute('aria-label', (this.strings.quickAdd || '') + ' — ' + card.t);
        add.innerHTML =
          '<svg class="icon icon--sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>';
        add.addEventListener('click', () => this.quickAdd(add, card.h));
        actions.appendChild(add);

        body.appendChild(actions);
        item.appendChild(body);

        item.addEventListener('click', (e) => {
          if (
            e.target.closest('.curator__card-add') ||
            e.target.closest('.curator__card-favorite') ||
            e.target.closest('.curator__card-view')
          ) return;
          const anchor = e.target.closest('a');
          if (anchor && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return;
          e.preventDefault();
          this.openPreview(card.h, item);
        });
        wrap.appendChild(item);
      }

      if (afterEl && afterEl.parentNode === this.messagesEl) afterEl.after(wrap);
      else this.messagesEl.appendChild(wrap);
      this.renderShortlist(cards);
      this.scrollToEnd();
      return wrap;
    }

    async quickAdd(button, handle) {
      if (button.disabled) return;
      button.disabled = true;
      button.classList.add('is-busy');
      try {
        const product = await fetchJSON('/products/' + encodeURIComponent(handle) + '.js', FETCH_TIMEOUT);
        const variant = (product.variants || []).find((v) => v.available) || (product.variants || [])[0];
        if (!variant) throw new Error('No variant');
        await AirX.cart.add({ id: variant.id, quantity: 1 });
        this.fireEvent('card_add', handle);
        const record = compactFromAjax(product);
        this.rememberRecent(record);

      } catch (err) {
        this.renderErrorOnce(this.strings.cartError || this.strings.errorOffline || '', 'cart');
      } finally {
        button.disabled = false;
        button.classList.remove('is-busy');
      }
    }

    ensurePreview() {
      if (this.previewEl) return this.previewEl;

      const view = document.createElement('div');
      view.className = 'curator__preview';
      view.dataset.curatorPreview = '';
      view.hidden = true;
      view.setAttribute('role', 'group');
      view.setAttribute('aria-label', this.strings.previewLabel || '');

      const back = document.createElement('button');
      back.type = 'button';
      back.className = 'curator__preview-back';
      back.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M19 12H5m7-7-7 7 7 7"/></svg>';
      const backLabel = document.createElement('span');
      backLabel.textContent = this.strings.previewBack || '';
      back.appendChild(backLabel);
      back.addEventListener('click', () => this.closePreview(true));

      const modes = document.createElement('div');
      modes.className = 'curator__preview-modes';
      modes.hidden = true;
      modes.setAttribute('role', 'group');
      modes.setAttribute('aria-label', this.strings.previewModesLabel || '');
      const modePhotos = document.createElement('button');
      modePhotos.type = 'button';
      modePhotos.className = 'curator__preview-mode is-active';
      modePhotos.setAttribute('aria-pressed', 'true');
      modePhotos.textContent = this.strings.previewPhotos || '';
      modePhotos.addEventListener('click', () => this.setPreviewMode('photos'));
      const mode3d = document.createElement('button');
      mode3d.type = 'button';
      mode3d.className = 'curator__preview-mode';
      mode3d.setAttribute('aria-pressed', 'false');
      mode3d.textContent = this.strings.preview3d || '';
      mode3d.addEventListener('click', () => this.setPreviewMode('3d'));
      modes.append(modePhotos, mode3d);

      const stage = document.createElement('div');
      stage.className = 'curator__preview-stage';
      const image = document.createElement('img');
      image.alt = '';
      image.decoding = 'async';
      image.width = 800;
      image.height = 1000;
      stage.appendChild(image);

      const viewerHost = document.createElement('div');
      viewerHost.className = 'curator__preview-viewer';
      viewerHost.hidden = true;
      stage.appendChild(viewerHost);

      let loupe = null;
      if (window.matchMedia('(pointer: fine)').matches) {
        loupe = document.createElement('div');
        loupe.className = 'curator__preview-loupe';
        loupe.setAttribute('aria-hidden', 'true');
        stage.appendChild(loupe);
        stage.addEventListener('pointermove', (e) => this.movePreviewLoupe(e));
        stage.addEventListener('pointerleave', () => this.hidePreviewLoupe());
        stage.addEventListener('pointerdown', () => this.hidePreviewLoupe());
      }

      view.addEventListener('canvas-viewer:unsupported', () => {
        this._webglBlocked = null;
        if (!this.webglAvailable()) modes.hidden = true;
        this.setPreviewMode('photos');
        this.destroyPreviewViewer();
      });

      const body = document.createElement('div');
      body.className = 'curator__preview-body';

      const title = document.createElement('h3');
      title.className = 'curator__preview-title';
      const price = document.createElement('p');
      price.className = 'curator__preview-price';
      const options = document.createElement('div');
      options.className = 'curator__preview-options';
      const desc = document.createElement('p');
      desc.className = 'curator__preview-desc';

      const actions = document.createElement('div');
      actions.className = 'curator__preview-actions';

      const add = document.createElement('button');
      add.type = 'button';
      add.className = 'curator__preview-add';
      add.textContent = this.strings.previewAdd || '';
      add.addEventListener('click', () => this.previewAddToCart());

      const favorite = document.createElement('button');
      favorite.type = 'button';
      favorite.className = 'curator__card-favorite curator__preview-favorite';
      favorite.addEventListener('click', () => {
        const state = this._preview;
        const record = state && this.productIndex.get(state.handle);
        if (record) this.toggleFavorite(record);
      });

      const details = document.createElement('a');
      details.className = 'curator__preview-details';
      details.target = '_blank';
      details.rel = 'noopener';
      details.textContent = this.strings.previewDetails || '';
      details.addEventListener('click', () => {
        const state = this._preview;
        const record = state && this.productIndex.get(state.handle);
        if (record) this.rememberRecent(record);
      });

      actions.append(add, favorite, details);

      const status = document.createElement('p');
      status.className = 'curator__preview-status';
      status.setAttribute('role', 'status');
      status.hidden = true;

      const live = document.createElement('p');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');

      body.append(title, price, options, desc, actions, status, live);
      view.append(back, modes, stage, body);

      this.messagesEl.after(view);
      this.previewEl = view;
      this.previewEls = { back, modes, modePhotos, mode3d, stage, viewerHost, loupe, image, title, price, options, desc, add, favorite, details, status, live };
      return view;
    }

    openPreview(rawHandle, trigger) {
      const handle = clean(rawHandle, 100).toLowerCase();
      if (!handle) return;
      this.fireEvent('preview_open', handle);
      this.ensurePreview();
      if (!this._previewOpen) {

        this.cancelRevealTour();
        this._previewReturnScroll = this.scrollEl ? this.scrollEl.scrollTop : 0;
        this._previewTrigger = trigger || null;
      }
      this._previewOpen = true;
      this._previewSeq += 1;
      const seq = this._previewSeq;
      this._preview = { handle, product: null, variants: [], optionNames: [], selected: [], variant: null };

      this.destroyPreviewViewer();
      this.setPreviewMode('photos');
      this.classList.add('curator--preview-open');
      this.previewEl.hidden = false;
      if (this.scrollEl) this.scrollEl.scrollTop = 0;

      const record = this.productIndex.get(handle) || null;
      if (record) this.rememberRecent(record);
      this.renderPreviewBase(handle, record);
      this.fetchProductDetails(handle).then((product) => {
        if (!this._previewOpen || this._previewSeq !== seq) return;
        if (!product) {
          this.previewEls.desc.textContent = '';
          this.setPreviewStatus(this.strings.previewError || '', true);
          return;
        }
        this.renderPreviewProduct(product);
      });
      this.previewEls.back.focus({ preventScroll: true });
    }

    closePreview(restoreFocus) {
      if (!this._previewOpen) return;
      this._previewOpen = false;
      this._preview = null;

      this.destroyPreviewViewer();
      this.setPreviewMode('photos');
      if (this._previewStatusTimer) window.clearTimeout(this._previewStatusTimer);
      this._previewStatusTimer = null;
      if (this.previewEls) this.previewEls.live.textContent = '';
      this.classList.remove('curator--preview-open');
      if (this.previewEl) this.previewEl.hidden = true;

      if (this.scrollEl) this.scrollEl.scrollTop = this._previewReturnScroll;
      const trigger = this._previewTrigger;
      this._previewTrigger = null;
      if (!restoreFocus) return;
      let target = trigger && trigger.isConnected ? trigger.querySelector('.curator__card-view') : null;
      if (!target) target = this.panel;
      if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
    }

    renderPreviewBase(handle, record) {
      const els = this.previewEls;
      els.title.textContent = record ? record.t : '';
      els.price.textContent = record
        ? (record.min ? interp(this.strings.priceFrom || '[price]', { price: money(record.min) }) : clean(record.p, 80))
        : '';
      els.options.textContent = '';
      els.desc.textContent = this.strings.previewLoading || '';
      els.add.textContent = this.strings.previewAdd || '';
      els.add.disabled = true;
      els.add.classList.remove('is-busy');
      els.details.href = '/products/' + encodeURIComponent(handle);
      els.favorite.dataset.curatorFavorite = handle;
      this.syncFavoriteButtons(handle);
      this.setPreviewStatus('', false);
      if (els.modes) els.modes.hidden = true;
      const src = cdnImage(record ? this.roomAwareImg(record) : '');
      els.image.hidden = !src;
      if (src) {
        els.image.src = sized(src, 800);
        els.image.dataset.zoomSrc = sized(src, 1600);
      } else {
        els.image.removeAttribute('src');
        delete els.image.dataset.zoomSrc;
      }
    }

    renderPreviewProduct(product) {
      const state = this._preview;
      if (!state) return;
      const record = compactFromAjax(product);
      this.productIndex.set(record.h, record);
      this.rememberRecent(record);

      const variants = Array.isArray(product.variants) ? product.variants.filter((v) => v && v.id != null) : [];
      const names = (Array.isArray(product.options) ? product.options : []).map((option) =>
        clean(typeof option === 'string' ? option : option && option.name, 40)
      );
      state.product = product;
      state.variants = variants;
      state.optionNames = names;

      const first = variants.find((v) => v.available) || variants[0] || null;
      state.selected = first ? names.map((name, i) => first['option' + (i + 1)]) : [];
      state.variant = first;

      const els = this.previewEls;
      els.title.textContent = record.t;

      const src = cdnImage(this.roomImageFromProduct(product) || product.featured_image || record.img);
      els.image.hidden = !src || this._previewMode === '3d';
      if (src) {
        els.image.src = sized(src, 800);
        els.image.dataset.zoomSrc = sized(src, 1600);
      } else {
        els.image.removeAttribute('src');
        delete els.image.dataset.zoomSrc;
      }
      this.updatePreviewModes(product);

      const full = decodeEntities(clean(product.description, PREVIEW_DESC_MAX + 80));
      els.desc.textContent = full.length > PREVIEW_DESC_MAX
        ? full.slice(0, PREVIEW_DESC_MAX).replace(/\s+\S*$/, '') + '…'
        : full;

      this.renderPreviewOptions();
      this.updatePreviewSelection();
    }

    renderPreviewOptions() {
      const state = this._preview;
      const els = this.previewEls;
      els.options.textContent = '';
      if (!state || !state.variants.length) return;
      const frag = document.createDocumentFragment();
      state.optionNames.forEach((name, index) => {
        const values = [];
        for (const variant of state.variants) {
          const value = variant['option' + (index + 1)];
          if (value != null && !values.includes(value)) values.push(value);
        }
        if (!values.length) return;
        if (state.optionNames.length === 1 && values.length === 1 && values[0] === 'Default Title') return;
        const group = document.createElement('div');
        group.className = 'curator__preview-option';
        group.setAttribute('role', 'group');
        if (name) group.setAttribute('aria-label', name);
        if (name && name !== 'Title') {
          const label = document.createElement('span');
          label.className = 'curator__preview-option-name';
          label.textContent = name;
          group.appendChild(label);
        }
        const pills = document.createElement('div');
        pills.className = 'curator__preview-pills';
        for (const value of values) {
          const pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'curator__preview-pill';
          pill.textContent = clean(value, 60);
          pill.dataset.optionIndex = String(index);
          pill.dataset.optionValue = value;
          pill.addEventListener('click', () => this.selectPreviewOption(index, value));
          pills.appendChild(pill);
        }
        group.appendChild(pills);
        frag.appendChild(group);
      });
      els.options.appendChild(frag);
    }

    selectPreviewOption(index, value) {
      const state = this._preview;
      if (!state || !state.variants.length) return;
      state.selected[index] = value;
      const exact = state.variants.find((v) =>
        state.selected.every((sel, i) => v['option' + (i + 1)] === sel)
      );
      let variant = exact || null;
      if (!variant || !variant.available) {

        const snapped = state.variants.find((v) => v.available && v['option' + (index + 1)] === value);
        if (snapped) {
          state.selected = state.optionNames.map((name, i) => snapped['option' + (i + 1)]);
          variant = snapped;
        }
      }
      if (!variant) variant = state.variants.find((v) => v['option' + (index + 1)] === value) || null;
      state.variant = variant;
      this.updatePreviewSelection();
    }

    updatePreviewSelection() {
      const state = this._preview;
      if (!state) return;
      const els = this.previewEls;
      for (const pill of els.options.querySelectorAll('.curator__preview-pill')) {
        const index = Number(pill.dataset.optionIndex);
        const value = pill.dataset.optionValue;
        const active = state.selected[index] === value;
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-pressed', String(active));
        const anyAvailable = state.variants.some((v) => v.available && v['option' + (index + 1)] === value);
        pill.disabled = !anyAvailable && !active;
      }
      const variant = state.variant;
      if (variant && variant.price != null) els.price.textContent = money(variant.price);
      const canAdd = !!(variant && variant.available);
      els.add.disabled = !canAdd;
      els.add.textContent = canAdd ? this.strings.previewAdd || '' : this.strings.previewSoldOut || '';
      this.syncPreviewViewerDims();
    }

    async previewAddToCart() {
      const state = this._preview;
      const els = this.previewEls;
      const variant = state && state.variant;
      if (!variant || !variant.available || els.add.classList.contains('is-busy')) return;
      els.add.classList.add('is-busy');
      els.add.disabled = true;
      this.setPreviewStatus('', false);

      const seq = this._previewSeq;
      try {

        await AirX.cart.add({ id: variant.id, quantity: 1 }, { silent: true });
        const record = this.productIndex.get(state.handle);
        if (record) this.rememberRecent(record);
        if (this._previewOpen && this._previewSeq === seq) {
          this.setPreviewStatus(this.strings.previewAdded || '', false, true);
        }
      } catch (err) {
        if (this._previewOpen && this._previewSeq === seq) {
          this.setPreviewStatus(this.strings.cartError || this.strings.errorOffline || '', true);
        }
      } finally {
        els.add.classList.remove('is-busy');
        const current = this._preview && this._preview.variant;
        els.add.disabled = !(current && current.available);
      }
    }

    setPreviewStatus(text, isError, autoHide) {
      const status = this.previewEls && this.previewEls.status;
      if (!status) return;
      if (this._previewStatusTimer) window.clearTimeout(this._previewStatusTimer);
      this._previewStatusTimer = null;
      status.textContent = text;
      status.hidden = !text;
      status.classList.toggle('curator__preview-status--error', !!isError);
      if (text && autoHide) {
        this._previewStatusTimer = window.setTimeout(() => {
          status.hidden = true;
          this._previewStatusTimer = null;
        }, 3200);
      }
    }

    fetchProductDetails(handle) {
      if (!this._productCache.has(handle)) {
        const promise = fetchJSON('/products/' + encodeURIComponent(handle) + '.js', FETCH_TIMEOUT).catch(() => {
          this._productCache.delete(handle);
          return null;
        });
        this._productCache.set(handle, promise);
      }
      return this._productCache.get(handle);
    }

    webglAvailable() {
      if (this._webglBlocked != null) return !this._webglBlocked;
      let ok = false;
      try {
        const probe = document.createElement('canvas');
        ok = !!(probe.getContext('webgl2') || probe.getContext('webgl'));
      } catch (err) {
        ok = false;
      }
      this._webglBlocked = !ok;
      return ok;
    }

    updatePreviewModes(product) {
      const els = this.previewEls;
      if (!els || !els.modes) return;
      const art = cdnImage(product && product.featured_image);
      const available = !!(art && this.dataset.threeSrc && this.dataset.viewerSrc && this.webglAvailable());
      els.modes.hidden = !available;
      if (!available && this._previewMode === '3d') this.setPreviewMode('photos');
    }

    movePreviewLoupe(e) {
      const els = this.previewEls;
      const loupe = els && els.loupe;
      if (!loupe || this._previewMode === '3d' || e.pointerType !== 'mouse') return;
      const img = els.image;
      if (!img || img.hidden || !img.currentSrc) return this.hidePreviewLoupe();

      const rect = img.getBoundingClientRect();
      const inX = e.clientX >= rect.left && e.clientX <= rect.right;
      const inY = e.clientY >= rect.top && e.clientY <= rect.bottom;
      if (!inX || !inY) return this.hidePreviewLoupe();

      const stageRect = els.stage.getBoundingClientRect();
      const relX = e.clientX - rect.left;
      const relY = e.clientY - rect.top;

      const src = img.dataset.zoomSrc || img.currentSrc;
      if (this._loupeSrc !== src) {
        this._loupeSrc = src;
        loupe.style.backgroundImage = 'url("' + src + '")';
      }

      loupe.style.backgroundSize = (rect.width * LOUPE_ZOOM) + 'px ' + (rect.height * LOUPE_ZOOM) + 'px';
      loupe.style.backgroundPosition =
        (-(relX * LOUPE_ZOOM - LOUPE_SIZE / 2)) + 'px ' + (-(relY * LOUPE_ZOOM - LOUPE_SIZE / 2)) + 'px';
      loupe.style.left = (e.clientX - stageRect.left) + 'px';
      loupe.style.top = (e.clientY - stageRect.top) + 'px';
      loupe.classList.add('is-active');
    }

    hidePreviewLoupe() {
      const els = this.previewEls;
      if (els && els.loupe) els.loupe.classList.remove('is-active');
    }

    setPreviewMode(mode) {
      const els = this.previewEls;
      if (!els) return;
      const is3d = mode === '3d' && this._previewOpen;
      this._previewMode = is3d ? '3d' : 'photos';
      this.hidePreviewLoupe();
      if (els.modePhotos) {
        els.modePhotos.classList.toggle('is-active', !is3d);
        els.modePhotos.setAttribute('aria-pressed', String(!is3d));
      }
      if (els.mode3d) {
        els.mode3d.classList.toggle('is-active', is3d);
        els.mode3d.setAttribute('aria-pressed', String(is3d));
      }
      els.image.hidden = is3d || !els.image.getAttribute('src');
      if (els.viewerHost) els.viewerHost.hidden = !is3d;
      if (els.stage) els.stage.classList.toggle('curator__preview-stage--3d', is3d);
      if (is3d) this.mountPreviewViewer();
      else if (this._previewViewer && this._previewViewer.sleep) this._previewViewer.sleep();
    }

    ensureViewerAssets() {
      if (this._viewerAssetsPromise) return this._viewerAssetsPromise;
      const inject = (src, ready) => {
        if (ready) return Promise.resolve(true);
        if (!src) return Promise.resolve(false);
        return new Promise((resolve) => {
          const script = document.createElement('script');
          script.src = src;
          script.async = true;
          script.addEventListener('load', () => resolve(true));
          script.addEventListener('error', () => resolve(false));
          document.head.appendChild(script);
        });
      };
      this._viewerAssetsPromise = Promise.all([
        inject(this.dataset.viewerSrc, !!customElements.get('canvas-viewer-3d')),
        inject(this.dataset.artMapSrc, !!window.AIRX_MINI_ART),
        inject(this.dataset.dywMapSrc, !!window.DYW_ART_MAP),
      ]).then((results) => {
        const ok = results[0] && !!customElements.get('canvas-viewer-3d');
        if (!ok) this._viewerAssetsPromise = null;
        return ok;
      });
      return this._viewerAssetsPromise;
    }

    previewVariantDims() {
      const state = this._preview;
      const out = { size: '', depth: '' };
      const variant = state && state.variant;
      if (!variant) return out;
      for (const opt of [variant.option1, variant.option2, variant.option3]) {
        const value = String(opt == null ? '' : opt);
        if (!value) continue;
        if (!out.size && ART_SIZE_RE.test(value)) out.size = value;
        if (!out.depth && /inch/i.test(value)) out.depth = value;
      }
      return out;
    }

    syncPreviewViewerDims() {
      const viewer = this._previewViewer;
      if (!viewer || typeof viewer.setDimensions !== 'function') return;
      const dims = this.previewVariantDims();
      const size = parseArtSize(dims.size);
      const depth = parseArtDepth(dims.depth);
      if (!size && depth == null) return;
      const current = viewer.dims || { w: 24, h: 30, d: 1.5 };

      viewer.setDimensions(
        size ? size.w : current.w,
        size ? size.h : current.h,
        depth == null ? current.d : depth,
        this._previewMode === '3d'
      );
    }

    async mountPreviewViewer() {
      const state = this._preview;
      const els = this.previewEls;
      if (!state || !state.product || !els || !els.viewerHost) return;
      if (this._previewViewer) {
        if (this._previewViewer.activate) this._previewViewer.activate();
        return;
      }
      const handle = state.handle;
      const art = cdnImage(state.product.featured_image);
      if (!art) return;
      const loaded = await this.ensureViewerAssets();

      if (!this._previewOpen || this._previewMode !== '3d' || this._previewViewer) return;
      if (!this._preview || this._preview.handle !== handle) return;
      if (!loaded) {
        this.setPreviewMode('photos');
        return;
      }
      const viewer = document.createElement('canvas-viewer-3d');
      viewer.className = 'curator__preview-canvas';
      viewer.dataset.threeSrc = this.dataset.threeSrc;

      viewer.dataset.texture = sized(art, 1024);
      const dims = this.previewVariantDims();
      if (dims.size) viewer.dataset.initialSize = dims.size;
      if (dims.depth) viewer.dataset.initialDepth = dims.depth;
      if (this.strings.viewerDims) viewer.dataset.dimsTemplate = this.strings.viewerDims;
      const dimsEl = document.createElement('span');
      dimsEl.className = 'curator__preview-viewer-dims';
      dimsEl.dataset.viewerDims = '';
      dimsEl.setAttribute('aria-live', 'polite');
      viewer.appendChild(dimsEl);
      if (this.strings.viewerHint) {
        const hint = document.createElement('span');
        hint.className = 'curator__preview-viewer-hint';
        hint.setAttribute('aria-hidden', 'true');
        hint.textContent = this.strings.viewerHint;
        viewer.appendChild(hint);
      }
      els.viewerHost.appendChild(viewer);
      this._previewViewer = viewer;
      if (viewer.activate) viewer.activate();
    }

    destroyPreviewViewer() {
      const viewer = this._previewViewer;
      this._previewViewer = null;
      if (!viewer) return;
      if (viewer.sleep) viewer.sleep();
      viewer.remove();
    }

    startRevealTour() {
      this.cancelRevealTour();
      const body = this.messagesEl && (this.messagesEl.closest('[data-curator-scroll]') || this.messagesEl.closest('.drawer__body'));
      if (!body) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.scrollToEnd(true);
        return;
      }
      if (!this._revealBound) {
        this._revealBound = true;
        const cancel = () => this.cancelRevealTour();
        body.addEventListener('wheel', cancel, { passive: true });
        body.addEventListener('touchstart', cancel, { passive: true });
        body.addEventListener('pointerdown', cancel);
      }
      const SPEED = 330;
      const SETTLE_MS = 500;
      const MAX_MS = 15000;

      const state = { last: performance.now(), started: performance.now(), settled: 0, timer: 0 };
      this._reveal = state;
      const step = () => {
        if (this._reveal !== state) return;
        const now = performance.now();
        const dt = Math.min((now - state.last) / 1000, 0.35);
        state.last = now;
        const target = body.scrollHeight - body.clientHeight;
        const gap = target - body.scrollTop;
        if (gap <= 1) {
          state.settled += dt * 1000;
          if (state.settled >= SETTLE_MS) { this._reveal = null; return; }
        } else {
          state.settled = 0;
          body.scrollTop = Math.min(body.scrollTop + SPEED * dt, target);
        }
        if (now - state.started > MAX_MS) { this._reveal = null; return; }
        state.timer = window.setTimeout(step, 16);
      };
      state.timer = window.setTimeout(step, 16);
    }

    cancelRevealTour() {
      if (this._reveal) {
        window.clearTimeout(this._reveal.timer);
        this._reveal = null;
      }
    }

    scrollToEnd(force) {

      if (this._previewOpen) return;
      const body = this.messagesEl.closest('[data-curator-scroll]') || this.messagesEl.closest('.drawer__body');
      if (!body) return;

      if (!force && body.scrollHeight - body.scrollTop - body.clientHeight > 64) return;
      body.scrollTop = body.scrollHeight;
    }

    restoreTranscript() {
      const raw = ssGet(SS.transcript);
      if (!raw) return [];
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.slice(-MAX_TRANSCRIPT) : [];
      } catch (err) {
        return [];
      }
    }

    saveTranscript() {
      this.transcript = this.transcript.slice(-MAX_TRANSCRIPT);
      ssSet(SS.transcript, JSON.stringify(this.transcript));
    }

    resetConversation() {
      this.generation += 1;
      this.clearExternalPrompt();
      this.clearAvatarInteraction(true);
      this.closePreview(false);
      this.abortStream();
      this.clearArtJobs();
      this.transcript = [];
      this.activeCategory = null;
      this._errorState = Object.create(null);
      ssRemove(SS.transcript);
      this.messagesEl.textContent = '';
      this.cancelGreetingTimer();
      this._pacedGreeting = null;
      this.renderPacedGreeting(this.strings.greeting || '');
      this.updateChipsVisibility();
      this.updateProTip();
      if (this.input) this.input.focus({ preventScroll: true });
    }

    armPulse() {
      if (ssGet(SS.opened) || ssGet(SS.pulsed)) return;
      setTimeout(() => {
        if (this.isOpen || ssGet(SS.opened) || ssGet(SS.pulsed)) return;
        ssSet(SS.pulsed, '1');
        this.launcher.classList.add('is-pulsing');
        setTimeout(() => this.launcher.classList.remove('is-pulsing'), 4200);
      }, PULSE_DELAY_MS);
    }

    armTeaser() {
      if (!this.teaser || this.pageType !== 'index') return;
      if (ssGet(SS.opened) || ssGet(SS.teaser)) return;

      let timer = null;
      const events = ['pointerdown', 'keydown', 'scroll'];
      const disarm = () => {
        clearTimeout(timer);
        events.forEach((name) => window.removeEventListener(name, rearm));
      };
      const show = () => {
        disarm();
        if (this.isOpen || ssGet(SS.opened) || ssGet(SS.teaser)) return;
        ssSet(SS.teaser, '1');
        this.teaser.hidden = false;
      };
      const rearm = () => {
        clearTimeout(timer);
        timer = setTimeout(show, TEASER_IDLE_MS);
      };
      events.forEach((name) => window.addEventListener(name, rearm, { passive: true }));
      rearm();

      const openBtn = this.teaser.querySelector('[data-curator-teaser-open]');
      const dismissBtn = this.teaser.querySelector('[data-curator-teaser-dismiss]');
      if (openBtn) {
        openBtn.addEventListener('click', () => {
          this.hideTeaser(true);
          this.open(this.launcher);
        });
      }
      if (dismissBtn) dismissBtn.addEventListener('click', () => this.hideTeaser(true));
    }

    hideTeaser(markSeen) {
      if (!this.teaser) return;
      this.teaser.hidden = true;
      if (markSeen) ssSet(SS.teaser, '1');
    }
  }

  customElements.define('sales-curator', SalesCurator);
}
